import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import { useState } from "react";

export const EmailIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.214"
      height="14.404"
      viewBox="0 0 20.214 14.404"
      {...rest}
    >
      <g
        id="b9ead43d6481426bb3442c0ed4992ee5"
        transform="translate(-2.08 -10.68)"
      >
        <path
          id="Path_25"
          data-name="Path 25"
          d="M19.423,25.084H4.951A2.875,2.875,0,0,1,2.08,22.212V13.551A2.875,2.875,0,0,1,4.951,10.68H19.423a2.875,2.875,0,0,1,2.871,2.871v8.661A2.875,2.875,0,0,1,19.423,25.084ZM4.951,11.693a1.858,1.858,0,0,0-1.858,1.858v8.661A1.858,1.858,0,0,0,4.951,24.07H19.423a1.858,1.858,0,0,0,1.858-1.858V13.551a1.858,1.858,0,0,0-1.858-1.858Z"
          fill={rest.color || "#1b4a97"}
        />
        <path
          id="Path_26"
          data-name="Path 26"
          d="M12.718,23.447a2.875,2.875,0,0,1-1.733-.578L3.1,16.9a.507.507,0,1,1,.611-.807L11.6,22.069a1.875,1.875,0,0,0,2.243,0L21.727,16.1a.507.507,0,1,1,.611.807l-7.888,5.966a2.875,2.875,0,0,1-1.733.578Z"
          transform="translate(-0.531 -3.511)"
          fill={rest.color || "#1b4a97"}
        />
        <path
          id="Path_27"
          data-name="Path 27"
          d="M3.175,36.286a.507.507,0,0,1-.338-.885l6.216-5.543a.507.507,0,0,1,.676.757L3.513,36.157A.493.493,0,0,1,3.175,36.286Zm18.8,0a.493.493,0,0,1-.338-.128l-6.216-5.543a.507.507,0,1,1,.676-.757L22.312,35.4a.507.507,0,0,1-.338.885Z"
          transform="translate(-0.389 -12.614)"
          fill={rest.color || "#1b4a97"}
        />
      </g>
    </svg>
  );
};

export const PhoneIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.988"
      height="19.927"
      viewBox="0 0 19.988 19.927"
      {...rest}
    >
      <path
        id="_7d6cc54b80562adb170817079e2f888a"
        data-name="7d6cc54b80562adb170817079e2f888a"
        d="M19.41,13a3.147,3.147,0,0,1-.67-.12,9.86,9.86,0,0,1-1.31-.39,2,2,0,0,0-2.48,1l-.22.46a13.17,13.17,0,0,1-2.67-2,13.17,13.17,0,0,1-2-2.67l.46-.21a2,2,0,0,0,1-2.48,10.47,10.47,0,0,1-.39-1.32c-.05-.22-.09-.45-.12-.67a3,3,0,0,0-3-2.49H5a2.99,2.99,0,0,0-2.97,3.4A19.008,19.008,0,0,0,18.44,21.92a2.56,2.56,0,0,0,.39,0,2.993,2.993,0,0,0,3-3v-3A3,3,0,0,0,19.41,13Zm.49,6a1.005,1.005,0,0,1-1.15.99,17.16,17.16,0,0,1-9.87-4.84A17.16,17.16,0,0,1,4,5.25,1.005,1.005,0,0,1,5,4.1H8a1,1,0,0,1,1,.78,3.935,3.935,0,0,0,.15.82,11,11,0,0,0,.46,1.54l-1.4.66a1.042,1.042,0,0,0-.52,1.32,14.49,14.49,0,0,0,7,7,1.042,1.042,0,0,0,1.32-.52l.63-1.4a12.41,12.41,0,0,0,1.58.46c.26.06.54.11.81.15a1,1,0,0,1,.78,1ZM14,2h-.7a1,1,0,1,0,.17,2H14a6,6,0,0,1,6,6v.53a1,1,0,0,0,.91,1.08h.08a1,1,0,0,0,1-.91V10A8,8,0,0,0,14,2Zm2,8a1,1,0,0,0,2,0,4,4,0,0,0-4-4,1,1,0,0,0,0,2A2,2,0,0,1,16,10Z"
        transform="translate(-2.002 -2)"
        fill="#1b4a97"
      />
    </svg>
  );
};

export const PhoneIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.342"
      height="16.372"
      viewBox="0 0 16.342 16.372"
    >
      <path
        id="Icon_feather-phone-call"
        data-name="Icon feather-phone-call"
        d="M12.638,4.428a3.66,3.66,0,0,1,2.891,2.891M12.638,1.5a6.588,6.588,0,0,1,5.819,5.812m-.732,5.841v2.2a1.464,1.464,0,0,1-1.6,1.464,14.485,14.485,0,0,1-6.317-2.247,14.273,14.273,0,0,1-4.392-4.392A14.485,14.485,0,0,1,3.174,3.828a1.464,1.464,0,0,1,1.457-1.6h2.2A1.464,1.464,0,0,1,8.29,3.491,9.4,9.4,0,0,0,8.8,5.548a1.464,1.464,0,0,1-.329,1.544l-.93.93a11.711,11.711,0,0,0,4.392,4.392l.93-.93a1.464,1.464,0,0,1,1.544-.329,9.4,9.4,0,0,0,2.057.512A1.464,1.464,0,0,1,17.725,13.153Z"
        transform="translate(-2.667 -0.948)"
        fill={rest.color || "none"}
        stroke="#9191a6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </svg>
  );
};

export const FaxIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.289"
      height="15.289"
      viewBox="0 0 15.289 15.289"
    >
      <path
        id="Icon_awesome-fax"
        data-name="Icon awesome-fax"
        d="M1.911,3.822H.956A.956.956,0,0,0,0,4.778v9.556a.956.956,0,0,0,.956.956h.956a.956.956,0,0,0,.956-.956V4.778A.956.956,0,0,0,1.911,3.822Zm12.422.956V2.307a.956.956,0,0,0-.28-.676L12.7.28A.956.956,0,0,0,12.026,0H4.778a.956.956,0,0,0-.956.956V14.333a.956.956,0,0,0,.956.956h9.556a.956.956,0,0,0,.956-.956v-8.6A.956.956,0,0,0,14.333,4.778ZM8.6,12.9a.478.478,0,0,1-.478.478H7.167a.478.478,0,0,1-.478-.478v-.956a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478Zm0-3.822a.478.478,0,0,1-.478.478H7.167a.478.478,0,0,1-.478-.478V8.122a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478ZM12.422,12.9a.478.478,0,0,1-.478.478h-.956a.478.478,0,0,1-.478-.478v-.956a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478Zm0-3.822a.478.478,0,0,1-.478.478h-.956a.478.478,0,0,1-.478-.478V8.122a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478ZM12.9,5.733H5.256v-4.3h6.211v.956a.478.478,0,0,0,.478.478H12.9Z"
        fill="#9191a6"
      />
    </svg>
  );
};

export const LocationIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.574"
      height="15.318"
      viewBox="0 0 9.574 15.318"
    >
      <path
        id="Icon_metro-location"
        data-name="Icon metro-location"
        d="M13.142,1.928A4.787,4.787,0,0,0,8.355,6.715c0,4.787,4.787,10.531,4.787,10.531S17.929,11.5,17.929,6.715a4.787,4.787,0,0,0-4.787-4.787Zm0,7.719a2.932,2.932,0,1,1,2.932-2.932A2.932,2.932,0,0,1,13.142,9.647ZM11.287,6.715A1.855,1.855,0,1,1,13.142,8.57,1.855,1.855,0,0,1,11.287,6.715Z"
        transform="translate(-8.355 -1.928)"
        fill={rest.color || '#9191a6'}
      />
    </svg>
  );
};

export const SearchIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26.703"
      height="26.703"
      viewBox="0 0 26.703 26.703"
      {...rest}
    >
      <path
        id="search"
        d="M29.264,27.158l-5.042-5.027a11.745,11.745,0,0,0,2.506-7.267A11.864,11.864,0,1,0,14.864,26.728a11.746,11.746,0,0,0,7.267-2.506l5.027,5.042a1.489,1.489,0,1,0,2.106-2.106ZM5.966,14.864a8.9,8.9,0,1,1,8.9,8.9,8.9,8.9,0,0,1-8.9-8.9Z"
        transform="translate(-3 -3)"
        fill="#1b4a97"
      />
    </svg>
  );
};

export const FacebookIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="102"
      height="101"
      viewBox="0 0 102 101"
      onMouseEnter={() => {
        setColor(rest.color || "#fff");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
    >
      <defs>
        <filter
          id="Ellipse_6"
          x="0"
          y="0"
          width="102"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_11_4"
        data-name="Component 11 – 4"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_6)">
          <ellipse
            id="Ellipse_6-2"
            data-name="Ellipse 6"
            cx="42"
            cy="41.5"
            rx="42"
            ry="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          id="Icon_awesome-facebook-f"
          data-name="Icon awesome-facebook-f"
          d="M23.928,25.084l1.239-8.07H17.423V11.776c0-2.208,1.082-4.36,4.55-4.36h3.52V.545A42.932,42.932,0,0,0,19.244,0C12.867,0,8.7,3.865,8.7,10.863v6.151H1.609v8.07H8.7v19.51h8.725V25.084Z"
          transform="translate(28.385 18.463)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const FacebookIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.435"
      height="30.686"
      viewBox="0 0 16.435 30.686"
      {...rest}
    >
      <path
        id="Icon_awesome-facebook-f"
        data-name="Icon awesome-facebook-f"
        d="M16.967,17.261l.852-5.553H12.491V8.1c0-1.519.744-3,3.131-3h2.422V.375A29.541,29.541,0,0,0,13.744,0C9.356,0,6.487,2.66,6.487,7.475v4.232H1.609v5.553H6.487V30.685h6V17.261Z"
        transform="translate(-1.609)"
        fill={rest.color || "#fff"}
      />
    </svg>
  );
};

export const InstagramIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="102"
      height="101"
      viewBox="0 0 102 101"
      onMouseEnter={() => {
        setColor(rest.color || "#fff");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
    >
      <defs>
        <filter
          id="Ellipse_7"
          x="0"
          y="0"
          width="102"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_9_9"
        data-name="Component 9 – 9"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_7)">
          <ellipse
            id="Ellipse_7-2"
            data-name="Ellipse 7"
            cx="42"
            cy="41.5"
            rx="42"
            ry="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          id="Icon_awesome-instagram"
          data-name="Icon awesome-instagram"
          d="M21.738,12.827A11.144,11.144,0,1,0,32.882,23.971,11.127,11.127,0,0,0,21.738,12.827Zm0,18.389a7.245,7.245,0,1,1,7.245-7.245,7.258,7.258,0,0,1-7.245,7.245Zm14.2-18.845a2.6,2.6,0,1,1-2.6-2.6A2.593,2.593,0,0,1,35.937,12.371Zm7.381,2.638c-.165-3.482-.96-6.566-3.511-9.107S34.182,2.565,30.7,2.39c-3.589-.2-14.345-.2-17.934,0-3.472.165-6.557.96-9.107,3.5S.322,11.517.147,15c-.2,3.589-.2,14.345,0,17.934.165,3.482.96,6.566,3.511,9.107s5.625,3.336,9.107,3.511c3.589.2,14.345.2,17.934,0,3.482-.165,6.566-.96,9.107-3.511s3.336-5.625,3.511-9.107c.2-3.589.2-14.335,0-17.924ZM38.682,36.783a7.335,7.335,0,0,1-4.132,4.132c-2.861,1.135-9.651.873-12.812.873s-9.961.252-12.812-.873a7.335,7.335,0,0,1-4.132-4.132c-1.135-2.861-.873-9.651-.873-12.812s-.252-9.961.873-12.812A7.335,7.335,0,0,1,8.925,7.027c2.861-1.135,9.651-.873,12.812-.873S31.7,5.9,34.55,7.027a7.335,7.335,0,0,1,4.132,4.132c1.135,2.861.873,9.651.873,12.812S39.817,33.932,38.682,36.783Z"
          transform="translate(20.287 19.226)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const InstagramIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.916"
      height="29.91"
      viewBox="0 0 29.916 29.91"
      {...rest}
    >
      <path
        id="Icon_awesome-instagram"
        data-name="Icon awesome-instagram"
        d="M14.956,9.524a7.668,7.668,0,1,0,7.668,7.668A7.656,7.656,0,0,0,14.956,9.524Zm0,12.654a4.985,4.985,0,1,1,4.985-4.985,4.995,4.995,0,0,1-4.985,4.985ZM24.727,9.21a1.789,1.789,0,1,1-1.789-1.789A1.784,1.784,0,0,1,24.727,9.21Zm5.079,1.815A8.852,8.852,0,0,0,27.39,4.759a8.91,8.91,0,0,0-6.267-2.416c-2.469-.14-9.871-.14-12.34,0A8.9,8.9,0,0,0,2.516,4.752,8.88,8.88,0,0,0,.1,11.019c-.14,2.469-.14,9.871,0,12.34a8.851,8.851,0,0,0,2.416,6.267,8.921,8.921,0,0,0,6.267,2.416c2.469.14,9.871.14,12.34,0a8.851,8.851,0,0,0,6.267-2.416,8.91,8.91,0,0,0,2.416-6.267c.14-2.469.14-9.864,0-12.334Zm-3.19,14.983a5.047,5.047,0,0,1-2.843,2.843c-1.969.781-6.641.6-8.816.6s-6.854.174-8.816-.6A5.047,5.047,0,0,1,3.3,26.009c-.781-1.969-.6-6.641-.6-8.816s-.174-6.854.6-8.816A5.047,5.047,0,0,1,6.14,5.533c1.969-.781,6.641-.6,8.816-.6s6.854-.174,8.816.6a5.047,5.047,0,0,1,2.843,2.843c.781,1.969.6,6.641.6,8.816S27.4,24.047,26.616,26.009Z"
        transform="translate(0.005 -2.238)"
        fill={rest.color || "#fff"}
      />
    </svg>
  );
};

export const PinterestIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="101"
      height="101"
      viewBox="0 0 101 101"
      onMouseEnter={() => {
        setColor(rest.color || "#fff");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
    >
      <defs>
        <filter
          id="Ellipse_5"
          x="0"
          y="0"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_12_4"
        data-name="Component 12 – 4"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_5)">
          <circle
            id="Ellipse_5-2"
            data-name="Ellipse 5"
            cx="41.5"
            cy="41.5"
            r="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          id="Icon_awesome-pinterest"
          data-name="Icon awesome-pinterest"
          d="M47.3,23.565c0,12.707-10.586,23-23.651,23a24.169,24.169,0,0,1-7-1.03,25.55,25.55,0,0,0,2.937-6.029c.286-1.076,1.469-5.472,1.469-5.472.772,1.428,3.023,2.643,5.417,2.643,7.134,0,12.274-6.381,12.274-14.312,0-7.6-6.38-13.282-14.582-13.282-10.2,0-15.631,6.66-15.631,13.922,0,3.376,1.85,7.578,4.8,8.914.448.2.687.111.792-.306.076-.315.477-1.883.658-2.606a.675.675,0,0,0-.162-.659,8.894,8.894,0,0,1-1.745-5.25c0-5.074,3.948-9.98,10.681-9.98,5.808,0,9.88,3.849,9.88,9.359C33.436,28.7,30.2,33.017,26,33.017a3.364,3.364,0,0,1-3.5-4.155c.668-2.736,1.955-5.686,1.955-7.661a2.92,2.92,0,0,0-2.995-3.237c-2.375,0-4.282,2.384-4.282,5.584a8.1,8.1,0,0,0,.706,3.413s-2.337,9.628-2.766,11.427a21.662,21.662,0,0,0-.086,6.6A23.036,23.036,0,0,1,0,23.565c0-12.707,10.586-23,23.651-23S47.3,10.858,47.3,23.565Z"
          transform="translate(18.459 17.9)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const PinterestIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32.549"
      height="31.657"
      viewBox="0 0 32.549 31.657"
      {...rest}
    >
      <path
        id="Icon_awesome-pinterest"
        data-name="Icon awesome-pinterest"
        d="M32.549,16.391A16.053,16.053,0,0,1,16.275,32.219a16.631,16.631,0,0,1-4.817-.708,17.581,17.581,0,0,0,2.021-4.149c.2-.74,1.011-3.766,1.011-3.766a4.4,4.4,0,0,0,3.727,1.819c4.909,0,8.446-4.391,8.446-9.848,0-5.227-4.39-9.14-10.034-9.14-7.022,0-10.756,4.583-10.756,9.58,0,2.323,1.273,5.214,3.3,6.133.308.14.472.077.545-.211.052-.217.328-1.3.453-1.793a.464.464,0,0,0-.112-.453,6.12,6.12,0,0,1-1.2-3.612A6.951,6.951,0,0,1,16.209,9.2c4,0,6.8,2.649,6.8,6.44,0,4.283-2.225,7.25-5.119,7.25a2.315,2.315,0,0,1-2.408-2.859c.459-1.883,1.345-3.912,1.345-5.272a2.009,2.009,0,0,0-2.061-2.227c-1.634,0-2.946,1.64-2.946,3.842a5.575,5.575,0,0,0,.486,2.349S10.7,25.352,10.4,26.59a14.906,14.906,0,0,0-.059,4.544A15.851,15.851,0,0,1,0,16.391,16.053,16.053,0,0,1,16.275.563,16.053,16.053,0,0,1,32.549,16.391Z"
        transform="translate(0 -0.563)"
        fill={rest.color || "#fff"}
      />
    </svg>
  );
};

export const WhatsappIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="101"
      height="101"
      viewBox="0 0 101 101"
      onMouseEnter={() => {
        setColor(rest.color || "#fff");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
    >
      <defs>
        <filter
          id="Ellipse_8"
          x="0"
          y="0"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_13_4"
        data-name="Component 13 – 4"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_8)">
          <circle
            id="Ellipse_8-2"
            data-name="Ellipse 8"
            cx="41.5"
            cy="41.5"
            r="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          id="Icon_simple-whatsapp"
          data-name="Icon simple-whatsapp"
          d="M31.691,26.047c-.545-.272-3.2-1.57-3.695-1.75s-.857-.272-1.219.272-1.4,1.746-1.71,2.1-.632.38-1.17.136a14.7,14.7,0,0,1-4.352-2.69,16.431,16.431,0,0,1-3.006-3.749c-.315-.543-.034-.842.235-1.114.246-.245.545-.625.817-.947a4.591,4.591,0,0,0,.538-.9,1,1,0,0,0-.045-.949c-.136-.272-1.217-2.934-1.67-4-.435-1.058-.882-.924-1.217-.924-.312-.027-.672-.027-1.034-.027a2.042,2.042,0,0,0-1.443.65,6.046,6.046,0,0,0-1.893,4.483c0,2.635,1.938,5.189,2.208,5.569.27.353,3.812,5.787,9.237,8.123,1.293.543,2.3.869,3.086,1.139a7.493,7.493,0,0,0,3.4.219c1.04-.165,3.2-1.306,3.651-2.583a4.483,4.483,0,0,0,.326-2.581c-.134-.244-.489-.38-1.032-.625m-9.863,13.48h-.029a18.118,18.118,0,0,1-9.155-2.5l-.652-.388L5.216,38.271l1.82-6.6L6.6,30.99A17.963,17.963,0,0,1,34.58,8.831a17.727,17.727,0,0,1,5.269,12.66,17.985,17.985,0,0,1-17.993,17.9M37.164,6.247A21.991,21.991,0,0,0,21.815,0,21.534,21.534,0,0,0,3.072,32.307L0,43.467l11.473-2.992A21.846,21.846,0,0,0,21.815,43.1h.011A21.625,21.625,0,0,0,43.467,21.55a21.361,21.361,0,0,0-6.33-15.233"
          transform="translate(20 18.463)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const WhatsappIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.91"
      height="29.91"
      viewBox="0 0 29.91 29.91"
      {...rest}
    >
      <path
        id="Icon_simple-whatsapp"
        data-name="Icon simple-whatsapp"
        d="M21.807,17.923c-.375-.187-2.2-1.08-2.542-1.2s-.589-.187-.839.187-.961,1.2-1.176,1.448-.435.262-.805.093A10.115,10.115,0,0,1,13.449,16.6a11.307,11.307,0,0,1-2.069-2.58c-.217-.374-.024-.58.162-.766.169-.168.375-.43.562-.652a3.159,3.159,0,0,0,.37-.618.685.685,0,0,0-.031-.653c-.093-.187-.837-2.019-1.149-2.749s-.607-.636-.837-.636c-.214-.019-.462-.019-.712-.019a1.4,1.4,0,0,0-.993.447,4.161,4.161,0,0,0-1.3,3.084,7.292,7.292,0,0,0,1.519,3.832,16.617,16.617,0,0,0,6.356,5.589c.89.374,1.583.6,2.124.784a5.156,5.156,0,0,0,2.343.151A3.835,3.835,0,0,0,22.3,20.036a3.085,3.085,0,0,0,.224-1.776c-.092-.168-.336-.262-.71-.43m-6.787,9.276h-.02a12.467,12.467,0,0,1-6.3-1.72l-.449-.267L3.589,26.334l1.252-4.543-.3-.467A12.36,12.36,0,0,1,23.794,6.077a12.2,12.2,0,0,1,3.625,8.711A12.375,12.375,0,0,1,15.038,27.107M25.573,4.3A15.132,15.132,0,0,0,15.011,0a14.817,14.817,0,0,0-12.9,22.23L0,29.91l7.895-2.059a15.032,15.032,0,0,0,7.116,1.8h.007A14.88,14.88,0,0,0,29.91,14.829,14.7,14.7,0,0,0,25.554,4.347"
        fill={rest.color || "#fff"}
      />
    </svg>
  );
};

export const TwittterIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" {...rest}>
      <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" fill={rest.color || "#fff"}></path>
    </svg>
  );
};

export const TiktokIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" {...rest}>
      <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
      fill={rest.color || "#fff"}
      ></path>
    </svg>
  );
};
export const YoutubeIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="101"
      height="101"
      viewBox="0 0 101 101"
      onMouseEnter={() => {
        setColor(rest.color || "#fff");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
      widths={rest.widths || "101"}
    >
      <defs>
        <filter
          id="Ellipse_9"
          x="0"
          y="0"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_10_4"
        data-name="Component 10 – 4"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_9)">
          <circle
            id="Ellipse_9-2"
            data-name="Ellipse 9"
            cx="41.5"
            cy="41.5"
            r="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          fill={color}
          id="Icon_ionic-logo-youtube"
          data-name="Icon ionic-logo-youtube"
          d="M38.03,10.841A5.812,5.812,0,0,0,32.5,4.769C28.354,4.575,24.129,4.5,19.815,4.5H18.469c-4.307,0-8.539.075-12.682.269A5.825,5.825,0,0,0,.262,10.856C.075,13.518-.007,16.18,0,18.842s.075,5.324.254,7.993A5.832,5.832,0,0,0,5.78,32.929c4.352.2,8.816.292,13.355.284q6.819.022,13.355-.284a5.833,5.833,0,0,0,5.533-6.094c.179-2.669.262-5.331.254-8Q38.3,14.841,38.03,10.841ZM15.478,26.177V11.484L26.32,18.827Z"
          transform="translate(22 22.5)"
        />
      </g>
    </svg>
  );
};

export const YoutubeIconOutlined: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.419"
      height="23.569"
      viewBox="0 0 31.419 23.569"
      {...rest}
    >
      <path
        id="Icon_ionic-logo-youtube"
        data-name="Icon ionic-logo-youtube"
        d="M31.215,9.7a4.771,4.771,0,0,0-4.542-4.984c-3.4-.16-6.868-.221-10.409-.221h-1.1c-3.535,0-7.009.061-10.409.221a4.781,4.781,0,0,0-4.536,5C.061,11.9-.006,14.087,0,16.271s.061,4.37.209,6.561a4.787,4.787,0,0,0,4.536,5c3.572.166,7.236.239,10.961.233q5.6.018,10.961-.233a4.788,4.788,0,0,0,4.542-5c.147-2.191.215-4.376.209-6.567Q31.435,12.988,31.215,9.7ZM12.7,22.292V10.232l8.9,6.027Z"
        transform="translate(0 -4.5)"
        fill={rest.color || "#fff"}
      />
    </svg>
  );
};

export const OurMessageIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="83.009"
      height="83"
      viewBox="0 0 83.009 83"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_20"
            data-name="Rectangle 20"
            width="83.009"
            height="83"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_18" data-name="Group 18" clipPath="url(#clipPath)">
        <path
          id="Path_63"
          data-name="Path 63"
          d="M80.5,95c-3.625-2.818-7.207-5.691-10.8-8.544-1.587-1.258-3.168-2.525-4.767-3.768a1.367,1.367,0,0,0-2.018.113,1.384,1.384,0,0,0,.318,2.053c.063.052.128.1.191.152q6.062,4.808,12.126,9.614c1.26,1,2.517,2.005,3.816,3.038-.165.156-.253.253-.355.336q-18.156,14.4-36.315,28.8c-.959.76-1.416.751-2.363,0q-18.029-14.3-36.055-28.6c-.2-.158-.392-.325-.63-.526,2.627-2.081,5.165-4.1,7.7-6.109q4.093-3.245,8.186-6.495c.814-.648.985-1.44.489-2.1a1.451,1.451,0,0,0-2.207-.061Q9.845,89.212,1.876,95.525A4.69,4.69,0,0,0,0,99.449q.023,21.762.009,43.522a4.166,4.166,0,0,0,4.49,4.5q37,0,74,0a5.757,5.757,0,0,0,1.206-.1,4.322,4.322,0,0,0,3.309-3.3V98.355A6.261,6.261,0,0,0,80.5,95m-.253,47.743c0,1.551-.422,1.973-1.966,1.973H4.775c-1.6,0-2.005-.407-2.005-2.014V100.527L29.7,121.884c-5.111,4.052-10.1,8.013-15.095,11.974-2.306,1.83-4.617,3.654-6.915,5.492a1.375,1.375,0,0,0-.236,2.22c.578.531,1.243.5,2.038-.13q3.976-3.138,7.937-6.289c4.8-3.809,9.6-7.619,14.463-11.47.188.13.388.251.57.4q3.112,2.462,6.22,4.936a4.141,4.141,0,0,0,5.614.039c2.06-1.622,4.106-3.255,6.161-4.879.208-.167.424-.323.663-.5L60.6,131.19c4.275,3.389,8.542,6.79,12.832,10.157a2.058,2.058,0,0,0,1.356.537,1.943,1.943,0,0,0,1.146-.957c.312-.6-.052-1.141-.554-1.542q-2.342-1.871-4.693-3.732L53.863,122.31c-.147-.117-.288-.24-.522-.435l26.907-21.341Z"
          transform="translate(0 -64.475)"
          fill="#1b4a97"
        />
        <path
          id="Path_64"
          data-name="Path 64"
          d="M158.9,10.7A12.353,12.353,0,0,0,149.922.475c-.671-.186-1.356-.318-2.034-.474H145.3c-.312.067-.622.141-.936.2a12.447,12.447,0,0,0-3.825,23.123c.2.113.492.3.5.459.041,1.28.024,2.564.024,3.9-.552,0-.983-.013-1.412,0a4.142,4.142,0,0,0,.009,8.284c.45.015.9,0,1.354,0v2.772c-.52,0-.977-.013-1.434,0a4.137,4.137,0,0,0-.011,8.271c.479.015.957,0,1.507,0,0,.528,0,.955,0,1.38a4.1,4.1,0,0,0,4.091,4.147c.782.019,1.566.009,2.35.007,2.971-.007,4.6-1.639,4.6-4.615q0-11.753-.013-23.5a1.211,1.211,0,0,1,.674-1.206A12.184,12.184,0,0,0,158.9,10.7M150.553,21.27a1.877,1.877,0,0,0-1.211,1.953q.032,12.273.013,24.546c0,1.663-.364,2.018-2.055,2.021-.6,0-1.189,0-1.782,0-1.2-.011-1.674-.481-1.685-1.657-.007-.758.009-1.514,0-2.27a1.426,1.426,0,0,0-1.607-1.6c-.81-.013-1.62.011-2.43-.007a1.356,1.356,0,0,1-1.479-1.369,1.372,1.372,0,0,1,1.468-1.384c.81-.019,1.62,0,2.43-.009a1.424,1.424,0,0,0,1.616-1.583c.015-.862,0-1.728,0-2.592s.015-1.728,0-2.592a1.378,1.378,0,0,0-1.509-1.512c-.782-.017-1.566,0-2.348-.006-1.035-.015-1.648-.528-1.657-1.373-.011-.864.583-1.377,1.618-1.388.784-.011,1.568.015,2.35-.009a1.415,1.415,0,0,0,1.546-1.581c.015-1.917-.019-3.833.015-5.75a1.762,1.762,0,0,0-1.165-1.824,9.436,9.436,0,0,1-5.564-6.909,9.669,9.669,0,1,1,19.063-3.186,9.568,9.568,0,0,1-5.622,10.077"
          transform="translate(-105.084 -0.001)"
          fill="#1b4a97"
        />
        <path
          id="Path_65"
          data-name="Path 65"
          d="M108.175,12.476a1.209,1.209,0,0,1-1.453.751,23.124,23.124,0,0,1-3.034-1.092,1.227,1.227,0,0,1-.682-1.559c.178-.652.63-.972,1.624-1.027.89.362,2.09.764,3.2,1.338a1.141,1.141,0,0,1,.347,1.587"
          transform="translate(-80.649 -7.482)"
          fill="#1b4a97"
        />
        <path
          id="Path_66"
          data-name="Path 66"
          d="M260.132,12.164a24.452,24.452,0,0,1-3.03,1.1,1.213,1.213,0,0,1-1.475-.71,1.161,1.161,0,0,1,.359-1.65,33.878,33.878,0,0,1,3.151-1.3c.975.019,1.438.331,1.631.977a1.22,1.22,0,0,1-.637,1.577"
          transform="translate(-200.12 -7.53)"
          fill="#1b4a97"
        />
        <path
          id="Path_67"
          data-name="Path 67"
          d="M101.3,52.586a1.335,1.335,0,0,1-1.23,1.28,1.363,1.363,0,0,1-.162.011c-.459,0-.916,0-1.375,0V53.87c-.485,0-.972.028-1.455-.006A1.287,1.287,0,0,1,95.8,52.64a1.194,1.194,0,0,1,1.022-1.425,18.643,18.643,0,0,1,3.461.009,1.2,1.2,0,0,1,1.011,1.362"
          transform="translate(-75.053 -40.064)"
          fill="#1b4a97"
        />
        <path
          id="Path_68"
          data-name="Path 68"
          d="M267.6,52.6a1.287,1.287,0,0,1-1.254,1.239c-.483.037-.97.007-1.458.007-.511,0-1.027.03-1.535-.009a1.331,1.331,0,0,1-1.254-1.256,1.274,1.274,0,0,1,1.076-1.4,19.85,19.85,0,0,1,3.385.009A1.2,1.2,0,0,1,267.6,52.6"
          transform="translate(-205.332 -40.038)"
          fill="#1b4a97"
        />
        <path
          id="Path_69"
          data-name="Path 69"
          d="M108.246,90.075a3.265,3.265,0,0,1-.879.886,19.81,19.81,0,0,1-2.649.985,1.338,1.338,0,0,1-1.711-.814,1.324,1.324,0,0,1,.758-1.741,28.617,28.617,0,0,1,2.733-1c.927-.282,1.778.407,1.748,1.681"
          transform="translate(-80.624 -69.202)"
          fill="#1b4a97"
        />
        <path
          id="Path_70"
          data-name="Path 70"
          d="M261.048,90.322c.009,1.128-.795,1.858-1.624,1.622a25.437,25.437,0,0,1-2.961-1.074,1.359,1.359,0,0,1,.9-2.545,21.4,21.4,0,0,1,2.945,1.1c.372.18.583.7.736.892"
          transform="translate(-200.324 -69.157)"
          fill="#1b4a97"
        />
        <path
          id="Path_71"
          data-name="Path 71"
          d="M166.565,25.529a6.911,6.911,0,1,0,6.98,6.922,6.959,6.959,0,0,0-6.98-6.922m.048,11.052a4.139,4.139,0,0,1-4.143-4.1,4.152,4.152,0,1,1,8.3.017,4.137,4.137,0,0,1-4.16,4.085"
          transform="translate(-125.113 -20)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const OurVisionIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="108.04"
      height="93.318"
      viewBox="0 0 108.04 93.318"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_36"
            data-name="Rectangle 36"
            width="108.04"
            height="93.318"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_41" data-name="Group 41" clipPath="url(#clipPath)">
        <path
          id="Path_105"
          data-name="Path 105"
          d="M108.013,51.11c.044-5.181.022-10.344.022-15.525-.022-2.213-1.531-3.9-4-4.482-.9-.227-1.815-.4-2.734-.605-4.7-1.021-9.4-2.023-14.128-3.045V23.766a6.739,6.739,0,0,1,.7-.132,38.191,38.191,0,0,0,18.042-7.791c2.8-2.194,2.843-5.408.022-7.545-.35-.284-.722-.529-1.072-.794C90.911-2.879,70.9-2.444,57.56,8.543a4.249,4.249,0,0,0,.022,7,74.2,74.2,0,0,0,6.976,4.482,43.582,43.582,0,0,0,4.374,1.986q-6.758,7.2-13.472,14.334a.845.845,0,0,1-.7.189,8.053,8.053,0,0,0-6.561.737c-2.165-1.551-4.286-3.1-6.408-4.614,3.762-5.919.919-11.516-3.412-14.164A13.668,13.668,0,0,0,22.81,19.625c-3.7,3.1-5.752,9.417-.2,14.92-3.346,3.782-6.714,7.583-10.06,11.365-5.03-1.437-9.163-.3-11.416,3.1a6.838,6.838,0,0,0,1.837,9.342,9.718,9.718,0,0,0,11.11.284,7.215,7.215,0,0,0,3.105-4.2c.7-2.5-.109-4.709-1.9-6.675,3.412-3.839,6.758-7.621,10.126-11.422a13.873,13.873,0,0,0,14.15-1.38c2.165,1.57,4.286,3.1,6.32,4.576a16.534,16.534,0,0,0-.547,2.269c-.219,2.553,1.531,4.917,4.265,5.919a7.741,7.741,0,0,0,7.851-1.532,5.31,5.31,0,0,0,.919-6.9c-.241-.378-.547-.662-.087-1.154,4.636-4.9,9.229-9.833,13.865-14.75a1.078,1.078,0,0,1,.765-.3c1.247.189,2.471.454,3.7.681V33.3a22.865,22.865,0,0,0-2.559-1.1,11.257,11.257,0,0,0-2.734-.548c-3.871-.208-6.189,2.818-4.527,5.843.569,1.021,1.159,2.023,1.75,3.026a7.838,7.838,0,0,1,1.181,4.255c-.044,1.91.022,3.82-.022,5.73a10.255,10.255,0,0,0,3.127,7.621c1.159,1.21,2.274,2.458,3.434,3.706-.831,1.059-1.684,2.08-2.406,3.158a3.535,3.535,0,0,0-.634,1.815c-.044,7.488-.022,15-.022,22.484v1.021H57.56V66.182c2.952-1.078,4.2-3.2,3.018-5.408-1.356-2.553-2.8-5.087-4.374-7.564a4.813,4.813,0,0,0-7.851,0c-1.553,2.477-3,5.011-4.374,7.564-1.072,1.986-.022,4.2,2.274,5.125.262.113.525.208.744.284V90.292H36.675a1.443,1.443,0,0,1-.044-.151q-.033-16.991,0-33.982a.976.976,0,0,1,.59-.7c2.646-1.135,3.587-3.29,2.3-5.579-1.334-2.345-2.668-4.671-4.046-6.978a4.435,4.435,0,0,0-4.111-2.213,4.435,4.435,0,0,0-4.09,2.213c-1.378,2.345-2.756,4.709-4.09,7.072-1.225,2.212-.219,4.463,2.384,5.465.175.076.372.132.525.189V90.292H13.953c0-3.9-.022-7.715.022-11.535.022-.265.394-.624.7-.756,2.384-1,3.455-3.139,2.34-5.181-1.356-2.572-2.8-5.106-4.374-7.564a4.813,4.813,0,0,0-7.851.019c-1.553,2.477-3,5.011-4.374,7.564a3.479,3.479,0,0,0,1.465,4.69,12.689,12.689,0,0,0,1.553.738v12.14H.087v2.912h107.86V90.33h-3.39v-1.1c0-6.392-.153-12.8.044-19.194.109-2.931-.416-5.5-2.712-7.7a2.563,2.563,0,0,1-.394-.529c1.247-1.343,2.471-2.685,3.718-4.028a9.577,9.577,0,0,0,2.8-6.675M8.748,57.237c-2.887,0-5.249-2.042-5.249-4.557.022-2.5,2.406-4.52,5.314-4.482,2.843.038,5.139,2.08,5.139,4.538-.022,2.458-2.362,4.482-5.2,4.5M31.3,34.639c-4.746-.038-8.638-3.423-8.638-7.526.022-4.16,3.937-7.545,8.748-7.526,4.811,0,8.7,3.423,8.682,7.583-.022,4.141-3.98,7.507-8.792,7.47M52.268,45.172a3.28,3.28,0,0,1-3.477-3.082,3.325,3.325,0,0,1,3.543-2.931A3.29,3.29,0,0,1,55.767,42.2a3.3,3.3,0,0,1-3.5,2.969M12.706,75.3c-.7.038-1.378.019-2.187.019v15H6.954v-15c-.787,0-1.487.019-2.209-.019-1.072-.038-1.509-.624-1.05-1.456,1.312-2.307,2.624-4.614,3.98-6.883a1.16,1.16,0,0,1,2.1,0c1.356,2.288,2.668,4.576,3.98,6.883.459.832,0,1.418-1.05,1.456M35.275,52.718H33.11V90.33H29.677V52.718c-.9,0-1.618.019-2.34-.019-1.006-.038-1.443-.643-1.006-1.418,1.312-2.307,2.624-4.614,3.98-6.9a1.169,1.169,0,0,1,2.143.038q2,3.4,3.937,6.808c.481.87.022,1.456-1.115,1.494M56.226,63.251c-.372.019-.722,0-1.093,0H54.061V90.33H50.54V63.251c-.7,0-1.378.019-2.034,0-1.29-.019-1.75-.605-1.2-1.57,1.268-2.212,2.537-4.444,3.871-6.619a1.552,1.552,0,0,1,1.093-.737,1.489,1.489,0,0,1,1.093.7c1.356,2.212,2.646,4.463,3.915,6.713.5.87.066,1.475-1.05,1.513M99.287,7.617c1.553.927,3,1.986,4.44,3.026a1.546,1.546,0,0,1,.2,2.647,33.873,33.873,0,0,1-14.259,6.921c2.887-2.345,4.418-4.973,4.418-8.169S92.573,6.217,89.709,3.91a31.286,31.286,0,0,1,9.579,3.706M59.879,13.29a1.446,1.446,0,0,1-.109-2.364A32.68,32.68,0,0,1,73.984,3.948c-5.664,4.557-5.664,11.611.044,16.244a33.7,33.7,0,0,1-14.15-6.9m13.384-2.25c.656-3.574,3.849-6.2,7.873-6.505,3.915-.284,7.589,1.74,8.945,4.954a6.814,6.814,0,0,1-2.952,8.472c0-1.059.022-2,0-2.95A4.953,4.953,0,0,0,81.9,10.548c-2.843,0-5.161,1.967-5.227,4.463-.022.946,0,1.872,0,2.837-2.209-.813-3.893-4.236-3.412-6.808m27.8,78.156V90.33H76.674v-1.1c0-7.091.022-14.164-.022-21.255a4.852,4.852,0,0,1,.809-2.345c1.093-2,2.734-2.534,5.249-2.439,4.921.208,9.863.076,14.784.057a1.715,1.715,0,0,1,1.422.624,7.838,7.838,0,0,1,2.209,6.146c-.175,6.392-.066,12.783-.066,19.175m1.618-33.509c-1.225,1.362-2.449,2.723-3.74,4.028a2.005,2.005,0,0,1-1.268.511q-8.824.057-17.627,0A1.916,1.916,0,0,1,78.8,59.7c-1.268-1.286-2.493-2.61-3.7-3.952a6.754,6.754,0,0,1-1.9-4.784c0-2.023-.044-4.028,0-6.032a10.728,10.728,0,0,0-1.6-5.881c-.59-.946-1.137-1.891-1.662-2.855s-.022-1.588,1.247-1.532c2.974.113,5.446,2.345,5.467,5.049.044,2.288.022,4.576.022,6.94h3.477V15.389a1.69,1.69,0,0,1,1.793-1.834,1.657,1.657,0,0,1,1.684,1.834q.033,9.644.022,19.288V46.61h3.434V30.555c1.247.265,2.362.492,3.521.738V46.629h3.477V32.068c1.225.265,2.34.492,3.5.737V46.629h3.434V33.562a11.125,11.125,0,0,1,2.449.586,1.959,1.959,0,0,1,1.028,1.4q.1,8,.022,16a6.264,6.264,0,0,1-1.837,4.141"
          transform="translate(0 0.001)"
          fill="#1b4a97"
        />
        <path
          id="Path_106"
          data-name="Path 106"
          d="M17.165,11.948c-2.843.019-5.2,2.023-5.2,4.482-.022,2.515,2.362,4.557,5.249,4.557,2.843-.019,5.183-2.042,5.183-4.5.022-2.5-2.34-4.538-5.227-4.538m0,6.013a1.655,1.655,0,0,1-1.728-1.513,1.648,1.648,0,0,1,1.75-1.475,1.628,1.628,0,0,1,1.728,1.513,1.648,1.648,0,0,1-1.75,1.475"
          transform="translate(14.196 10.647)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const OurDutiesIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="130.306"
      height="131.692"
      viewBox="0 0 130.306 131.692"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_76"
            data-name="Rectangle 76"
            width="130.306"
            height="131.692"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_101" data-name="Group 101" clipPath="url(#clipPath)">
        <path
          id="Path_156"
          data-name="Path 156"
          d="M123.418,152.134q-2.953.006-5.915,0h5.915q3.821-.006,7.642,0Zm-4.2,11.609q-5.409.006-10.814,0h10.814c1.909,0,3.814,0,5.724,0q-2.864,0-5.724,0"
          transform="translate(-62.305 -87.44)"
          fill="#1b4a97"
        />
        <path
          id="Path_157"
          data-name="Path 157"
          d="M227.44,185.158c-.617-9.521-5.2-16.818-12.557-22.24.787-3.84,3.338-5.162,6.744-5.345a10.663,10.663,0,0,0,1.476-.17c1.186-.247,2.3-.706,2.058-2.186s-1.395-1.595-2.624-1.386c-1.65.276-3.3.557-5.035.85-.293-1.561-.523-2.875-.791-4.18-.272-1.357-.268-3.189-2.339-2.777-2.037.408-1.357,2.122-1.169,3.483a6.076,6.076,0,0,0,.238,1.25c1.186,3.211.213,5.9-2.075,8.416-15.662-7.255-31.723-.536-38.7,12.285a29.2,29.2,0,0,0,48.065,32.671,28.476,28.476,0,0,0,6.71-20.671m-5.919,12.9a25.651,25.651,0,1,1-45.348-23.886c7.544-12.9,23.444-15.6,33.39-9.887-.812,1.391-1.624,2.777-2.488,4.244-5.86-2.509-11.626-2.692-17.363-.034a20.063,20.063,0,0,0-10.265,10.572,20.494,20.494,0,0,0,35.508,19.969c5.728-7.978,5.749-20.348-4.746-28.759.842-1.433,1.62-2.764,2.4-4.1,8.6,4.588,15.092,18.826,8.909,31.876m-24.094-9.53c1.365.833,2.2-.081,2.866-1.233,1.118-1.956,2.275-3.887,3.419-5.83,2.862,1.812,3.368,7.051,1.331,10.048a8.135,8.135,0,0,1-10.3,2.764,8.008,8.008,0,0,1-4.023-9.683c1.463-4.142,5.128-6.1,9.946-5.06-1.233,2.139-2.343,4.091-3.478,6.026-.629,1.067-1.016,2.2.242,2.968m5.286-12.443c-8.458-1.186-13.331,1.229-15.419,7.578a11.582,11.582,0,0,0,20.186,10.576c3.083-3.955,4.121-10.372-1.718-16.223.816-1.408,1.65-2.849,2.488-4.295,6.685,3.785,8.99,14.135,4.92,21.522a16.916,16.916,0,0,1-29.814-15.989c4.159-7.867,14.131-11.358,21.836-7.433-.872,1.5-1.684,2.9-2.479,4.265"
          transform="translate(-97.203 -84.871)"
          fill="#1b4a97"
        />
        <path
          id="Path_158"
          data-name="Path 158"
          d="M102.1,66.969a3.094,3.094,0,0,1-1.833,1.314c-.468.038-1.174-.808-1.467-1.412a4.7,4.7,0,0,1-.077-1.888V8.418c0-3.912-.842-4.775-4.682-4.775q-41.991.013-83.981.03C5.3,3.672,3.5,5.462,3.5,10.2q-.006,55.609,0,111.218c0,4.865,1.765,6.617,6.685,6.621q33.06.006,66.121,0c.57,0,1.135-.013,1.7,0,1.288.038,2.513.238,2.488,1.905-.021,1.573-1.2,1.709-2.4,1.739-.353.009-.71,0-1.063,0q-33.379,0-66.759-.026a14.148,14.148,0,0,1-4.384-.566c-3.827-1.271-5.856-4.423-5.873-8.892-.026-9.925-.009-19.846-.009-29.771V65.855q0-28.072.009-56.141c0-4.6,1.863-7.625,5.673-9.024A11.643,11.643,0,0,1,9.624.045Q52.151-.019,94.669,0c4.869,0,7.527,2.653,7.531,7.463q.013,28.921,0,57.842c0,.566.179,1.288-.1,1.663"
          transform="translate(0 0)"
          fill="#1b4a97"
        />
        <path
          id="Path_159"
          data-name="Path 159"
          d="M52.619,137.1a5.868,5.868,0,0,0-5.987-6.153q-6.8-.185-13.608,0c-3.657.1-5.868,2.5-5.885,6.136-.026,4.61-.047,9.219.013,13.825a5.387,5.387,0,0,0,5.532,5.49c2.407.043,4.818.009,7.229.009,2.194,0,4.393.017,6.591,0,3.627-.03,6.026-2.258,6.106-5.9.1-4.465.085-8.93.009-13.4m-3.627,13.012c0,1.926-.9,2.866-2.866,2.824-2.122-.047-4.248-.013-6.374-.013s-4.252-.017-6.374,0c-1.841.021-2.764-.846-2.76-2.7q.006-6.481,0-12.966c0-1.863.927-2.709,2.76-2.7,4.248.013,8.5.026,12.749-.008,1.939-.017,2.887.842,2.875,2.807-.021,4.248-.013,8.5,0,12.753"
          transform="translate(-15.583 -75.21)"
          fill="#1b4a97"
        />
        <path
          id="Path_160"
          data-name="Path 160"
          d="M52.622,56.5c-.077-3.636-2.479-5.9-6.1-5.919-4.533-.026-9.07-.034-13.608,0A5.439,5.439,0,0,0,27.154,56.3c-.03,1.667-.021,3.333-.017,5,0,.6.009,1.2.009,1.8,0,1.36-.009,2.717-.009,4.082,0,.905,0,1.816.009,2.722.034,3.606,2.1,5.987,5.673,6.106,4.669.153,9.355.144,14.029,0a5.73,5.73,0,0,0,5.771-5.894c.111-4.533.1-9.075,0-13.608M48.99,69.788c-.009,1.833-.953,2.679-2.8,2.662q-6.379-.051-12.757,0c-1.982.013-2.819-.953-2.811-2.87.026-4.184-.013-8.365.017-12.545.013-2.262.68-2.917,2.9-2.938.91-.013,1.82-.013,2.734-.013,1.216,0,2.428,0,3.644,0,.621,0,1.242,0,1.863.009,1.505.009,3.011.013,4.516-.017,1.752-.03,2.683.778,2.692,2.526q.032,6.59,0,13.183"
          transform="translate(-15.595 -29.061)"
          fill="#1b4a97"
        />
        <path
          id="Path_161"
          data-name="Path 161"
          d="M52.622,217.862c-.068-3.338-2.343-5.83-5.473-5.907q-7.316-.179-14.637,0a5.444,5.444,0,0,0-5.358,5.69c-.03,1.718-.021,3.436-.017,5.154,0,.617.009,1.233.009,1.85,0,.663,0,1.331-.009,1.994,0,1.6-.009,3.2.013,4.8a5.66,5.66,0,0,0,5.987,5.97q6.685.07,13.37,0a5.848,5.848,0,0,0,6.115-5.966c.1-4.525.094-9.053,0-13.582m-3.636,13.119c-.026,2.126-.846,2.913-3.019,2.934q-6.168.064-12.332,0c-2.284-.025-2.989-.8-3-3.147q-.032-6.168,0-12.336c.017-2.3.617-2.9,2.9-2.951,1.471-.03,2.943-.021,4.414-.013.655,0,1.31,0,1.965,0q1.595.006,3.189,0t3.189,0c1.846,0,2.717.906,2.709,2.751-.021,4.252.026,8.509-.021,12.757"
          transform="translate(-15.595 -121.773)"
          fill="#1b4a97"
        />
        <path
          id="Path_162"
          data-name="Path 162"
          d="M137.429,154.007c-.055,1.587-1.352,1.757-2.645,1.757q-15.29-.013-30.575,0c-1.412,0-2.751-.281-2.717-1.918.03-1.527,1.357-1.735,2.666-1.727q1.735.006,3.461,0,5.913.013,11.826,0h7.642c2.547,0,5.1,0,7.646,0,1.348,0,2.756.1,2.7,1.88"
          transform="translate(-58.333 -87.434)"
          fill="#1b4a97"
        />
        <path
          id="Path_163"
          data-name="Path 163"
          d="M137.414,73.165c.06,1.761-1.314,1.893-2.679,1.889q-15.27-.013-30.537,0c-1.395,0-2.768-.208-2.717-1.884.047-1.561,1.425-1.654,2.7-1.65,5.09.017,10.176,0,15.266,0h15.27c1.233,0,2.632-.03,2.692,1.637"
          transform="translate(-58.326 -41.109)"
          fill="#1b4a97"
        />
        <path
          id="Path_164"
          data-name="Path 164"
          d="M129.006,172.708c.055,1.556-1.08,1.8-2.3,1.807q-2.864.006-5.724.009c-1.909,0-3.814,0-5.724,0H104.44c-1.386,0-3,.008-2.93-1.858.06-1.595,1.48-1.786,2.862-1.782,7.28.026,14.56.013,21.84.013h.425c1.246.009,2.318.336,2.369,1.812"
          transform="translate(-58.343 -98.217)"
          fill="#1b4a97"
        />
        <path
          id="Path_165"
          data-name="Path 165"
          d="M128.986,92.112c0,1.616-1.148,1.9-2.483,1.892-3.746-.013-7.493,0-11.235,0s-7.493-.021-11.239.013c-1.365.013-2.534-.378-2.556-1.867-.021-1.437,1.169-1.722,2.42-1.722q11.341.019,22.687.008c1.186,0,2.4.1,2.407,1.68"
          transform="translate(-58.322 -51.972)"
          fill="#1b4a97"
        />
        <path
          id="Path_166"
          data-name="Path 166"
          d="M125.826,234.681c.013,1.51-1.2,1.688-2.428,1.684-3.253-.013-6.506,0-9.759,0s-6.51-.009-9.764,0c-1.267,0-2.539-.383-2.271-1.765a3.063,3.063,0,0,1,2.369-1.7c6.434-.14,12.872-.068,19.31-.085,1.348,0,2.53.315,2.543,1.863"
          transform="translate(-58.377 -133.812)"
          fill="#1b4a97"
        />
        <path
          id="Path_167"
          data-name="Path 167"
          d="M117.857,253.593c-.753.574-1.48,1.612-2.254,1.641-4.014.17-8.041.17-12.051,0-.757-.034-1.467-1.106-2.2-1.7.753-.57,1.454-1.527,2.262-1.624a48.026,48.026,0,0,1,5.911-.081,52.53,52.53,0,0,1,6.128.081c.791.1,1.471,1.093,2.2,1.68"
          transform="translate(-58.253 -144.712)"
          fill="#1b4a97"
        />
        <path
          id="Path_168"
          data-name="Path 168"
          d="M54.751,152.667c-1.8,1.786-3.61,3.568-5.379,5.392-1.157,1.2-2.262,1.3-3.436.06q-.8-.848-1.641-1.654c-.889-.859-1.518-1.816-.515-2.926s2.007-.629,2.9.281c.247.247.515.468,1.1,1,1.565-1.654,3-3.206,4.478-4.72.855-.876,1.863-1.493,2.909-.37,1,1.059.481,2.045-.417,2.934"
          transform="translate(-24.868 -85.711)"
          fill="#1b4a97"
        />
        <path
          id="Path_169"
          data-name="Path 169"
          d="M54.743,72.711c-1.807,1.786-3.615,3.568-5.379,5.393-1.161,1.2-2.262,1.28-3.432.047-.583-.617-1.186-1.212-1.79-1.8-.85-.838-1.276-1.782-.361-2.777s1.875-.71,2.756.14c.3.289.612.57,1.25,1.157,1.573-1.667,3.011-3.215,4.482-4.733.859-.885,1.88-1.459,2.913-.353,1,1.059.455,2.05-.438,2.929"
          transform="translate(-24.868 -39.758)"
          fill="#1b4a97"
        />
        <path
          id="Path_170"
          data-name="Path 170"
          d="M54.639,232.717q-2.717,2.673-5.384,5.392c-1.1,1.123-2.173,1.178-3.287.038-.642-.655-1.3-1.293-1.939-1.948-.855-.867-1.25-1.977-.162-2.713.574-.387,1.709-.064,2.551.123.408.094.727.612,1.4,1.225,1.48-1.6,2.887-3.168,4.337-4.69.821-.863,1.8-1.6,2.9-.51,1.127,1.118.527,2.147-.421,3.083"
          transform="translate(-24.832 -131.669)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const WhoWeAreIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="80.388"
      height="68.157"
      viewBox="0 0 80.388 68.157"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_17"
            data-name="Rectangle 17"
            width="80.388"
            height="68.157"
            fill="#6b6b6b"
          />
        </clipPath>
      </defs>
      <g id="Group_11" data-name="Group 11" clipPath="url(#clipPath)">
        <path
          id="Path_49"
          data-name="Path 49"
          d="M16.856,193.047c-.085,7.554-.045,15.11-.024,22.664,0,.9.177,1.806.279,2.778H14.4c-2.3,0-4.6-.059-6.9.014A7.05,7.05,0,0,1,.086,212.48c-.006-.045-.057-.085-.086-.126v-14.91a23.668,23.668,0,0,1,1.042-3.42,11.1,11.1,0,0,1,9.76-6.809c2.282-.161,4.586-.028,6.943-.028-.051.22-.112.413-.142.609a38.191,38.191,0,0,0-.747,5.25"
          transform="translate(0 -150.35)"
          fill="#6b6b6b"
        />
        <path
          id="Path_50"
          data-name="Path 50"
          d="M146.673,191.086a2.354,2.354,0,0,1-2.687,2.689q-8,.006-16,0-7.961,0-15.922,0c-1.928,0-2.768-.841-2.768-2.766,0-7.609-.016-15.218,0-22.828a11.5,11.5,0,0,1,9.1-11.511,11.213,11.213,0,0,1,2.485-.267c4.731-.026,9.465-.047,14.2,0a11.484,11.484,0,0,1,11.32,9.14,12.608,12.608,0,0,1,.261,2.721q.029,11.414.01,22.826"
          transform="translate(-87.804 -125.636)"
          fill="#6b6b6b"
        />
        <path
          id="Path_51"
          data-name="Path 51"
          d="M161.324,13.844A13.953,13.953,0,1,1,147.381,0a14.04,14.04,0,0,1,13.943,13.844"
          transform="translate(-107.193 0)"
          fill="#6b6b6b"
        />
        <path
          id="Path_52"
          data-name="Path 52"
          d="M336.06,211.415a6.777,6.777,0,0,1-6.406,6.945c-3.546.161-7.106.035-10.562.035.055-1.867.147-3.688.155-5.51q.029-8.041,0-16.083c-.008-3.23.238-6.489-.971-9.6.151-.069.216-.124.281-.124,2.274.016,4.558-.083,6.821.077a11.468,11.468,0,0,1,10.67,11.238c.077,4.34.059,8.682.008,13.025"
          transform="translate(-255.716 -150.29)"
          fill="#6b6b6b"
        />
        <path
          id="Path_53"
          data-name="Path 53"
          d="M47.566,76.59A10.423,10.423,0,1,1,37.16,66.17,10.486,10.486,0,0,1,47.566,76.59"
          transform="translate(-21.468 -53.163)"
          fill="#6b6b6b"
        />
        <path
          id="Path_54"
          data-name="Path 54"
          d="M296.884,76.555A10.423,10.423,0,1,1,286.426,66.17a10.47,10.47,0,0,1,10.457,10.385"
          transform="translate(-221.777 -53.163)"
          fill="#6b6b6b"
        />
      </g>
    </svg>
  );
};

export const OurServicesIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="85.32"
      height="97.299"
      viewBox="0 0 85.32 97.299"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_62"
            data-name="Rectangle 62"
            width="85.32"
            height="97.299"
            fill="#6b6b6b"
          />
        </clipPath>
      </defs>
      <g id="Group_84" data-name="Group 84" clipPath="url(#clipPath)">
        <path
          id="Path_138"
          data-name="Path 138"
          d="M83.274,50.109a25.315,25.315,0,0,0-2.181-1.427.5.5,0,0,1-.311-.468c.015-1.474.009-2.947.012-4.421,0-2.178.006-4.356.025-6.537,0-.308-.068-.449-.4-.418a3.889,3.889,0,0,1-.846,0,.4.4,0,0,1-.28-.249c-.1-.578-.166-1.166-.243-1.751A50.629,50.629,0,0,0,76.5,24.067,30.414,30.414,0,0,0,68.858,12.06,30.453,30.453,0,0,0,54.091,4.627c-.286-.062-.375-.16-.372-.446.015-1.231-.006-2.461.018-3.692C53.747.1,53.63,0,53.239,0Q42.63.018,32.014,0c-.354,0-.428.117-.421.443.018,1.268.006,2.538.018,3.806,0,.225-.077.3-.286.36-1.7.483-3.424.883-5.076,1.489A27.636,27.636,0,0,0,10.8,19.6,46.463,46.463,0,0,0,6.138,35.89c-.117.96-.1.963-1.058.957-.56-.006-.551-.006-.551.56,0,3.615.006,7.227-.009,10.841a.582.582,0,0,1-.252.4c-.631.415-1.3.775-1.914,1.209A5.282,5.282,0,0,0,.087,53.3,9.763,9.763,0,0,0,.318,56.84c.018.1.234.209.36.215,3.316.117,6.633.191,9.949.332,4.095.175,8.19.428,12.284.6,4.71.2,9.423.421,14.136.5,4.381.074,8.765-.009,13.149-.062,2.381-.028,4.762-.114,7.144-.212,3.839-.157,7.679-.345,11.518-.526,2.5-.12,4.987-.268,7.485-.385,1.778-.083,3.556-.154,5.338-.2,1.086-.031,2.175-.006,3.286-.006.1-.6.206-1.141.28-1.686a5.331,5.331,0,0,0-1.972-5.3M53.734,8.488c0-.126.012-.252.022-.465.951.258,1.843.474,2.72.745a24.944,24.944,0,0,1,12.2,8.045,28.476,28.476,0,0,1,4.75,8.682,48.324,48.324,0,0,1,2.32,10.118,4.05,4.05,0,0,0,.1.643c.1.338.015.455-.338.388-1.7-.338-3.43-.594-5.11-1.021a49.367,49.367,0,0,1-10.761-4.233c-1.877-.991-3.707-2.07-5.562-3.1a.58.58,0,0,1-.345-.575q.014-9.612.012-19.222m.012,23.606c7.368,4.246,15.01,7.519,23.612,8.143v6.679c-.178-.065-.329-.114-.477-.175a52.4,52.4,0,0,0-10.149-2.815c-3.049-.545-6.113-.988-9.174-1.446-1.138-.169-2.289-.268-3.436-.375-.3-.031-.406-.12-.406-.44.006-3.073-.006-6.15-.012-9.226a2.821,2.821,0,0,1,.043-.345M35.036,3.962v-.5H50.307v.468q0,18.053-.009,36.1c0,.9,0,.9-.926.9H35.645c-.7,0-.606.034-.606-.591q0-18.186,0-36.373M9.676,34.887A47.8,47.8,0,0,1,11.9,25.494a28.323,28.323,0,0,1,5.375-9.414A25.1,25.1,0,0,1,28.553,8.857c.874-.286,1.769-.514,2.655-.766a3.339,3.339,0,0,1,.372-.062c.009.166.025.3.025.44q0,9.589.009,19.185a.614.614,0,0,1-.3.606,61.554,61.554,0,0,1-16.391,7.371c-1.689.446-3.43.692-5.15,1.028a1.968,1.968,0,0,1-.335,0c.083-.618.157-1.2.24-1.775M8.209,40.2a45.561,45.561,0,0,0,14.3-3.572A73.524,73.524,0,0,0,31,32.423c.175-.1.357-.185.569-.292a1.207,1.207,0,0,1,.058.249c0,3.073-.012,6.15-.012,9.223,0,.311-.037.452-.421.5a116.721,116.721,0,0,0-17.36,2.907c-1.861.5-3.673,1.178-5.507,1.775-.1.028-.191.055-.363.108v-.446q0-2.963-.015-5.922c0-.2.031-.3.261-.32M78.635,53.829c-4.479.222-8.956.461-13.435.668-3.495.163-6.99.3-10.485.415-2.944.1-5.891.206-8.836.222-3.636.022-7.273-.037-10.909-.083-1.972-.025-3.944-.083-5.916-.163-2.932-.117-5.861-.268-8.793-.406q-3.512-.166-7.024-.341l-9.211-.452c-.154-.006-.308,0-.458,0-.031-.031-.062-.062-.092-.1a3.936,3.936,0,0,1,.631-.794,12.614,12.614,0,0,1,1.667-1.089A41.777,41.777,0,0,1,17.8,47.546c2.889-.56,5.793-1.058,8.706-1.464,2.763-.388,5.541-.674,8.322-.9,2.194-.178,4.4-.261,6.6-.274,2.535-.012,5.076.034,7.6.182,2.569.148,5.132.4,7.688.7,2.4.283,4.793.646,7.18,1.046a53.167,53.167,0,0,1,12.312,3.3c1.489.64,2.923,1.409,4.356,2.169a5.2,5.2,0,0,1,1.037.9,2.16,2.16,0,0,1,.271.468c-1.151.052-2.2.1-3.246.148"
          transform="translate(0 0)"
          fill="#6b6b6b"
        />
        <path
          id="Path_139"
          data-name="Path 139"
          d="M92.543,195.927q-.212,2.6-.391,5.208c-.031.421-.329.446-.618.474-.932.089-1.864.163-2.793.246-.486.046-.972.08-1.452.148a2.354,2.354,0,0,0-1,4.246c1.163.821,2.307,1.664,3.473,2.477a.444.444,0,0,1,.169.637A37.747,37.747,0,0,1,85.067,218a8.314,8.314,0,0,0-.523.714c-.151.246-.289.271-.554.145-1.344-.631-2.717-1.2-4.042-1.861a2.362,2.362,0,0,0-3.24,2.409,3.815,3.815,0,0,0,.274.871q.854,1.929,1.744,3.846c.114.246.074.366-.142.535a40.118,40.118,0,0,1-9.451,5.451c-.258.108-.354-.006-.468-.166-.668-.923-1.329-1.852-1.994-2.778-.225-.311-.443-.628-.68-.932a2.13,2.13,0,0,0-2.544-.7,2.092,2.092,0,0,0-1.584,1.95c-.138,1.44-.277,2.88-.4,4.322-.025.271-.086.4-.391.446a37.787,37.787,0,0,1-8.623.24c-.766-.065-1.526-.172-2.289-.252a.369.369,0,0,1-.372-.394c-.123-1.391-.271-2.781-.385-4.172a2.341,2.341,0,0,0-2.633-2.292,2.134,2.134,0,0,0-1.707,1.1c-.514.7-1.012,1.421-1.517,2.129-.32.449-.646.9-.96,1.344a.312.312,0,0,1-.443.145,38.54,38.54,0,0,1-9.635-5.581,1.106,1.106,0,0,1-.12-.132q.844-1.846,1.686-3.692c.132-.292.262-.585.372-.886a2.08,2.08,0,0,0-.665-2.353,2.029,2.029,0,0,0-2.393-.5c-1.391.618-2.772,1.258-4.153,1.892-.172.077-.3.148-.458-.058a39.082,39.082,0,0,1-5.6-9.835c.1-.077.206-.166.317-.246,1.206-.868,2.412-1.738,3.621-2.6a2.123,2.123,0,0,0,.745-2.437,2.009,2.009,0,0,0-1.784-1.664c-1.271-.154-2.547-.255-3.824-.378-.268-.028-.532-.058-.8-.077-.283-.022-.32-.234-.335-.437q-.2-2.372-.375-4.747c-.022-.277,0-.56,0-.88.335,0,.637-.009.938,0,.6.025,1.2.077,1.8.08.3,0,.369.129.375.394.022.729.071,1.458.089,2.187.009.329.108.5.477.529a22.732,22.732,0,0,1,2.289.252,4.982,4.982,0,0,1,3.969,3.252,5.257,5.257,0,0,1-1.578,6.359q-.886.678-1.806,1.3c-.2.138-.249.265-.129.471q1.315,2.252,2.627,4.51c.126.218.283.2.486.1.517-.252,1.046-.477,1.563-.732a5.481,5.481,0,0,1,7.827,5.313,8.376,8.376,0,0,1-.44,1.812c-.255.7-.609,1.378-.944,2.123.935.575,1.849,1.157,2.784,1.7.631.366,1.3.668,1.935,1.018.237.132.363.077.5-.126.381-.545.775-1.083,1.166-1.621a5.494,5.494,0,0,1,9.82,2.667c.065.665.142,1.326.2,1.99a.3.3,0,0,0,.345.317q2.63,0,5.264,0c.243,0,.24-.145.258-.326a23.916,23.916,0,0,1,.338-2.781,5.253,5.253,0,0,1,4.572-3.975,5.139,5.139,0,0,1,5.085,2.1c.391.508.751,1.04,1.126,1.557.083.111.175.215.311.381,1.191-.677,2.372-1.338,3.544-2.012.332-.194.64-.431.972-.618a.514.514,0,0,0,.234-.812c-.255-.471-.446-.975-.68-1.461-1.837-3.812,1.283-7.6,4.645-7.814a5.864,5.864,0,0,1,2.855.637c.511.237,1.015.483,1.535.7a.355.355,0,0,0,.329-.1c.892-1.511,1.769-3.027,2.649-4.541.123-.212.058-.348-.132-.48-.535-.372-1.061-.76-1.591-1.144a5.05,5.05,0,0,1-2.212-3.87,5.444,5.444,0,0,1,4.91-5.987c.6-.055,1.2-.123,1.8-.163.326-.025.471-.138.471-.492.006-.729.058-1.458.083-2.187.009-.317.1-.465.474-.458.726.015,1.458-.034,2.187-.086.36-.025.511.068.48.455"
          transform="translate(-12.966 -135.333)"
          fill="#6b6b6b"
        />
        <path
          id="Path_140"
          data-name="Path 140"
          d="M82.917,209.232a8.126,8.126,0,0,1-4.449-4.39.535.535,0,0,0-.572-.372q-7.651.014-15.3.006h-.375a23.811,23.811,0,0,0,20.941,20.966c.006-.117.018-.2.018-.292q.009-7.725.022-15.45a.418.418,0,0,0-.286-.468m-2.873,12.284a.436.436,0,0,1-.031.08A20.518,20.518,0,0,1,66.1,207.685h.7c3.036,0,6.073.006,9.109-.009a.818.818,0,0,1,.8.428,10.114,10.114,0,0,0,3.16,3.095.409.409,0,0,1,.175.286q.009,5.016,0,10.032"
          transform="translate(-43.08 -141.566)"
          fill="#6b6b6b"
        />
        <path
          id="Path_141"
          data-name="Path 141"
          d="M167.75,204.476q-7.785,0-15.573-.006c-.28,0-.372.126-.465.345a7.966,7.966,0,0,1-4.344,4.387.5.5,0,0,0-.354.545q.009,7.67,0,15.342v.372a23.848,23.848,0,0,0,20.96-20.975c-.1,0-.157-.009-.221-.009m-8.131,11.2a20.458,20.458,0,0,1-9.479,5.95V221.2q0-4.79-.006-9.574a.528.528,0,0,1,.277-.52,9.84,9.84,0,0,0,3.123-3.076.68.68,0,0,1,.652-.354c3.153.015,6.3.009,9.457.012h.431a20.314,20.314,0,0,1-4.455,7.98"
          transform="translate(-101.784 -141.566)"
          fill="#6b6b6b"
        />
      </g>
    </svg>
  );
};

export const OurValuesIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="141.75"
      height="128.691"
      viewBox="0 0 141.75 128.691"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_21"
            data-name="Rectangle 21"
            width="141.75"
            height="128.691"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_21" data-name="Group 21" clipPath="url(#clipPath)">
        <path
          id="Path_72"
          data-name="Path 72"
          d="M164.506,207.2c-.482-10.366-5.6-18.516-15.264-24.324a36.489,36.489,0,0,0-15.836-4.866c5.481-1.428,9.817-4.189,12.728-8.543a16.082,16.082,0,0,0,2.253-14.029c-2.381-8.114-10.525-13.694-19.886-13.694-9.346,0-17.513,5.607-19.9,13.694a15.832,15.832,0,0,0,.93,11.679c2.7,5.617,7.508,9.139,14.45,10.909-1.458.174-2.467.285-3.469.419-14.571,1.91-26.809,13.442-27.808,26.506-.4,5.211-.188,10.463-.267,15.7a2.43,2.43,0,0,0,1.654,2.282h68.814a2.5,2.5,0,0,0,1.661-2.41c-.03-4.44.143-8.888-.064-13.321m-41.365-4.883c1.013-6.716,2.061-13.429,3.111-20.212h4.479c.565,3.579,1.13,7.135,1.691,10.691.456,2.9.878,5.808,1.375,8.7a2.529,2.529,0,0,1-.78,2.5c-1.526,1.478-2.919,3.06-4.513,4.749-1.774-1.88-3.447-3.623-5.067-5.406a1.361,1.361,0,0,1-.3-1.029m36.9,15.875a6.138,6.138,0,0,1-.075.654H150.5v-1.622c0-3.938.008-7.872,0-11.81a2.219,2.219,0,0,0-2.268-2.5c-1.382.007-2.234.952-2.238,2.527-.008,4.434,0,8.868,0,13.422H111.019v-2.145q0-5.65,0-11.307a2.266,2.266,0,1,0-4.505.034c-.008,4.434,0,8.868,0,13.385h-9.35c-.034-.037-.151-.1-.147-.161.124-5.885-.885-11.854,1.051-17.615,3.364-10.007,10.917-16.133,22.312-18.516a9.507,9.507,0,0,1,1.254-.08c-.478,3.15-.938,6.2-1.413,9.253-.588,3.77-1.239,7.537-1.737,11.317a2.849,2.849,0,0,0,.719,2.044c2.4,2.681,4.9,5.3,7.4,7.912a2.412,2.412,0,0,0,3.835-.017c2.5-2.614,5.006-5.221,7.387-7.919a3.117,3.117,0,0,0,.655-2.292c-.968-6.719-2.045-13.429-3.119-20.329.7.094,1.285.137,1.85.248,13.026,2.567,22.376,12.554,22.805,24.465.136,3.683.034,7.37.038,11.056"
          transform="translate(-57.618 -94.245)"
          fill="#1b4a97"
        />
        <path
          id="Path_73"
          data-name="Path 73"
          d="M170.205,19.029c-3.39,2.715-6.739,5.466-10.178,8.13a1.876,1.876,0,0,0-.8,2.249c1,3.955,1.9,7.929,2.878,11.89a1.951,1.951,0,0,1-.821,2.343,2.578,2.578,0,0,1-2.769-.037c-4.016-2.078-8.054-4.122-12.05-6.233a1.991,1.991,0,0,0-2.155.013c-3.918,2.068-7.88,4.062-11.813,6.1a2.787,2.787,0,0,1-3.014.154,2.093,2.093,0,0,1-.765-2.6c.964-3.877,1.846-7.768,2.829-11.642a1.882,1.882,0,0,0-.8-2.252c-3.371-2.6-6.649-5.3-9.971-7.956-.844-.674-1.533-1.374-1.123-2.49.4-1.093,1.367-1.351,2.524-1.454,4.343-.379,8.679-.841,13.026-1.18a2.649,2.649,0,0,0,2.573-1.649c1.62-3.475,3.36-6.9,5.123-10.319A14.316,14.316,0,0,1,144.537,0h1.691a14.1,14.1,0,0,1,1.646,2.1c1.752,3.375,3.507,6.753,5.063,10.2.6,1.32,1.484,1.669,2.916,1.783,4.347.342,8.683.8,13.026,1.193a2.3,2.3,0,0,1,2.238,1.431,1.951,1.951,0,0,1-.912,2.319"
          transform="translate(-74.502)"
          fill="#1b4a97"
        />
        <path
          id="Path_74"
          data-name="Path 74"
          d="M50.67,68.155c-3.394,2.711-6.758,5.453-10.19,8.124a1.82,1.82,0,0,0-.821,2.152c1.006,3.955,1.906,7.929,2.885,11.891a2.026,2.026,0,0,1-.832,2.463,2.572,2.572,0,0,1-2.765-.057c-3.978-2.061-7.978-4.082-11.926-6.187a2.208,2.208,0,0,0-2.392.03Q18.7,89.708,12.684,92.73c-1.895.958-3.7.087-3.643-1.937.584-2.48,1.22-5.181,1.861-7.879.377-1.6.7-3.2,1.172-4.779a1.322,1.322,0,0,0-.6-1.615C8.062,73.826,4.7,71.084,1.293,68.386c-.9-.717-1.582-1.475-1.168-2.6s1.507-1.341,2.693-1.444c4.577-.4,9.157-.811,13.723-1.3a2.077,2.077,0,0,0,1.341-.992c1.906-3.68,3.752-7.386,5.575-11.1.486-.982,1.059-1.81,2.407-1.8s1.91.875,2.384,1.84C30.061,54.663,31.914,58.322,33.7,62a1.81,1.81,0,0,0,1.755,1.119c4.63.369,9.252.831,13.874,1.253a2.381,2.381,0,0,1,2.253,1.454,1.969,1.969,0,0,1-.915,2.326"
          transform="translate(0 -32.678)"
          fill="#1b4a97"
        />
        <path
          id="Path_75"
          data-name="Path 75"
          d="M290.77,66.848a7.892,7.892,0,0,1-1.217,1.454q-5.034,4.117-10.163,8.147a1.521,1.521,0,0,0-.64,1.837c.991,3.874,1.88,7.765,2.806,11.649.252,1.052.452,2.1-.727,2.849s-2.211.238-3.258-.3c-3.85-2-7.726-3.968-11.561-6a1.991,1.991,0,0,0-2.147.023c-3.918,2.064-7.877,4.065-11.809,6.106a2.747,2.747,0,0,1-3.01.154,2.1,2.1,0,0,1-.765-2.6c.987-3.958,1.9-7.933,2.878-11.89a1.561,1.561,0,0,0-.667-1.85c-3.394-2.644-6.716-5.362-10.084-8.036-.881-.7-1.642-1.434-1.194-2.587.463-1.19,1.59-1.367,2.825-1.475,4.581-.392,9.161-.808,13.727-1.3a2.074,2.074,0,0,0,1.284-1.062c1.876-3.65,3.684-7.323,5.5-11a2.558,2.558,0,0,1,2.4-1.816c1.349,0,1.914.841,2.392,1.816,1.785,3.64,3.646,7.249,5.394,10.9a2.118,2.118,0,0,0,2.094,1.267c4.581.359,9.154.811,13.727,1.26a2.2,2.2,0,0,1,2.219,2.453"
          transform="translate(-149.019 -32.678)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const PhoneSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.342"
      height="16.372"
      viewBox="0 0 16.342 16.372"
      {...rest}
    >
      <path
        id="Icon_feather-phone-call"
        data-name="Icon feather-phone-call"
        d="M12.638,4.428a3.66,3.66,0,0,1,2.891,2.891M12.638,1.5a6.588,6.588,0,0,1,5.819,5.812m-.732,5.841v2.2a1.464,1.464,0,0,1-1.6,1.464,14.485,14.485,0,0,1-6.317-2.247,14.273,14.273,0,0,1-4.392-4.392A14.485,14.485,0,0,1,3.174,3.828a1.464,1.464,0,0,1,1.457-1.6h2.2A1.464,1.464,0,0,1,8.29,3.491,9.4,9.4,0,0,0,8.8,5.548a1.464,1.464,0,0,1-.329,1.544l-.93.93a11.711,11.711,0,0,0,4.392,4.392l.93-.93a1.464,1.464,0,0,1,1.544-.329,9.4,9.4,0,0,0,2.057.512A1.464,1.464,0,0,1,17.725,13.153Z"
        transform="translate(-2.667 -0.948)"
        fill="none"
        stroke="#9191a6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </svg>
  );
};

export const LocationSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9.574"
      height="15.318"
      viewBox="0 0 9.574 15.318"
      {...rest}
    >
      <path
        id="Icon_metro-location"
        data-name="Icon metro-location"
        d="M13.142,1.928A4.787,4.787,0,0,0,8.355,6.715c0,4.787,4.787,10.531,4.787,10.531S17.929,11.5,17.929,6.715a4.787,4.787,0,0,0-4.787-4.787Zm0,7.719a2.932,2.932,0,1,1,2.932-2.932A2.932,2.932,0,0,1,13.142,9.647ZM11.287,6.715A1.855,1.855,0,1,1,13.142,8.57,1.855,1.855,0,0,1,11.287,6.715Z"
        transform="translate(-8.355 -1.928)"
        fill="#9191a6"
      />
    </svg>
  );
};

export const FaxSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.289"
      height="15.289"
      viewBox="0 0 15.289 15.289"
      {...rest}
    >
      <path
        id="Icon_awesome-fax"
        data-name="Icon awesome-fax"
        d="M1.911,3.822H.956A.956.956,0,0,0,0,4.778v9.556a.956.956,0,0,0,.956.956h.956a.956.956,0,0,0,.956-.956V4.778A.956.956,0,0,0,1.911,3.822Zm12.422.956V2.307a.956.956,0,0,0-.28-.676L12.7.28A.956.956,0,0,0,12.026,0H4.778a.956.956,0,0,0-.956.956V14.333a.956.956,0,0,0,.956.956h9.556a.956.956,0,0,0,.956-.956v-8.6A.956.956,0,0,0,14.333,4.778ZM8.6,12.9a.478.478,0,0,1-.478.478H7.167a.478.478,0,0,1-.478-.478v-.956a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478Zm0-3.822a.478.478,0,0,1-.478.478H7.167a.478.478,0,0,1-.478-.478V8.122a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478ZM12.422,12.9a.478.478,0,0,1-.478.478h-.956a.478.478,0,0,1-.478-.478v-.956a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478Zm0-3.822a.478.478,0,0,1-.478.478h-.956a.478.478,0,0,1-.478-.478V8.122a.478.478,0,0,1,.478-.478h.956a.478.478,0,0,1,.478.478ZM12.9,5.733H5.256v-4.3h6.211v.956a.478.478,0,0,0,.478.478H12.9Z"
        fill="#9191a6"
      />
    </svg>
  );
};

export const WhatsappSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.91"
      height="29.91"
      viewBox="0 0 29.91 29.91"
      {...rest}
    >
      <path
        id="Icon_simple-whatsapp"
        data-name="Icon simple-whatsapp"
        d="M21.807,17.923c-.375-.187-2.2-1.08-2.542-1.2s-.589-.187-.839.187-.961,1.2-1.176,1.448-.435.262-.805.093A10.115,10.115,0,0,1,13.449,16.6a11.307,11.307,0,0,1-2.069-2.58c-.217-.374-.024-.58.162-.766.169-.168.375-.43.562-.652a3.159,3.159,0,0,0,.37-.618.685.685,0,0,0-.031-.653c-.093-.187-.837-2.019-1.149-2.749s-.607-.636-.837-.636c-.214-.019-.462-.019-.712-.019a1.4,1.4,0,0,0-.993.447,4.161,4.161,0,0,0-1.3,3.084,7.292,7.292,0,0,0,1.519,3.832,16.617,16.617,0,0,0,6.356,5.589c.89.374,1.583.6,2.124.784a5.156,5.156,0,0,0,2.343.151A3.835,3.835,0,0,0,22.3,20.036a3.085,3.085,0,0,0,.224-1.776c-.092-.168-.336-.262-.71-.43m-6.787,9.276h-.02a12.467,12.467,0,0,1-6.3-1.72l-.449-.267L3.589,26.334l1.252-4.543-.3-.467A12.36,12.36,0,0,1,23.794,6.077a12.2,12.2,0,0,1,3.625,8.711A12.375,12.375,0,0,1,15.038,27.107M25.573,4.3A15.132,15.132,0,0,0,15.011,0a14.817,14.817,0,0,0-12.9,22.23L0,29.91l7.895-2.059a15.032,15.032,0,0,0,7.116,1.8h.007A14.88,14.88,0,0,0,29.91,14.829,14.7,14.7,0,0,0,25.554,4.347"
        fill="#9191a6"
      />
    </svg>
  );
};

export const PinterestSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32.549"
      height="31.657"
      viewBox="0 0 32.549 31.657"
      {...rest}
    >
      <path
        id="Icon_awesome-pinterest"
        data-name="Icon awesome-pinterest"
        d="M32.549,16.391A16.053,16.053,0,0,1,16.275,32.219a16.631,16.631,0,0,1-4.817-.708,17.581,17.581,0,0,0,2.021-4.149c.2-.74,1.011-3.766,1.011-3.766a4.4,4.4,0,0,0,3.727,1.819c4.909,0,8.446-4.391,8.446-9.848,0-5.227-4.39-9.14-10.034-9.14-7.022,0-10.756,4.583-10.756,9.58,0,2.323,1.273,5.214,3.3,6.133.308.14.472.077.545-.211.052-.217.328-1.3.453-1.793a.464.464,0,0,0-.112-.453,6.12,6.12,0,0,1-1.2-3.612A6.951,6.951,0,0,1,16.209,9.2c4,0,6.8,2.649,6.8,6.44,0,4.283-2.225,7.25-5.119,7.25a2.315,2.315,0,0,1-2.408-2.859c.459-1.883,1.345-3.912,1.345-5.272a2.009,2.009,0,0,0-2.061-2.227c-1.634,0-2.946,1.64-2.946,3.842a5.575,5.575,0,0,0,.486,2.349S10.7,25.352,10.4,26.59a14.906,14.906,0,0,0-.059,4.544A15.851,15.851,0,0,1,0,16.391,16.053,16.053,0,0,1,16.275.563,16.053,16.053,0,0,1,32.549,16.391Z"
        transform="translate(0 -0.563)"
        fill="#9191a6"
      />
    </svg>
  );
};

export const FacebookSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.435"
      height="30.686"
      viewBox="0 0 16.435 30.686"
      {...rest}
    >
      <path
        id="Icon_awesome-facebook-f"
        data-name="Icon awesome-facebook-f"
        d="M16.967,17.261l.852-5.553H12.491V8.1c0-1.519.744-3,3.131-3h2.422V.375A29.541,29.541,0,0,0,13.744,0C9.356,0,6.487,2.66,6.487,7.475v4.232H1.609v5.553H6.487V30.685h6V17.261Z"
        transform="translate(-1.609)"
        fill="#9191a6"
      />
    </svg>
  );
};

export const InstagramSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.916"
      height="29.91"
      viewBox="0 0 29.916 29.91"
      {...rest}
    >
      <path
        id="Icon_awesome-instagram"
        data-name="Icon awesome-instagram"
        d="M14.956,9.524a7.668,7.668,0,1,0,7.668,7.668A7.656,7.656,0,0,0,14.956,9.524Zm0,12.654a4.985,4.985,0,1,1,4.985-4.985,4.995,4.995,0,0,1-4.985,4.985ZM24.727,9.21a1.789,1.789,0,1,1-1.789-1.789A1.784,1.784,0,0,1,24.727,9.21Zm5.079,1.815A8.852,8.852,0,0,0,27.39,4.759a8.91,8.91,0,0,0-6.267-2.416c-2.469-.14-9.871-.14-12.34,0A8.9,8.9,0,0,0,2.516,4.752,8.88,8.88,0,0,0,.1,11.019c-.14,2.469-.14,9.871,0,12.34a8.851,8.851,0,0,0,2.416,6.267,8.921,8.921,0,0,0,6.267,2.416c2.469.14,9.871.14,12.34,0a8.851,8.851,0,0,0,6.267-2.416,8.91,8.91,0,0,0,2.416-6.267c.14-2.469.14-9.864,0-12.334Zm-3.19,14.983a5.047,5.047,0,0,1-2.843,2.843c-1.969.781-6.641.6-8.816.6s-6.854.174-8.816-.6A5.047,5.047,0,0,1,3.3,26.009c-.781-1.969-.6-6.641-.6-8.816s-.174-6.854.6-8.816A5.047,5.047,0,0,1,6.14,5.533c1.969-.781,6.641-.6,8.816-.6s6.854-.174,8.816.6a5.047,5.047,0,0,1,2.843,2.843c.781,1.969.6,6.641.6,8.816S27.4,24.047,26.616,26.009Z"
        transform="translate(0.005 -2.238)"
        fill="#9191a6"
      />
    </svg>
  );
};

export const YoutubeSimpleIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31.419"
      height="23.569"
      viewBox="0 0 31.419 23.569"
      {...rest}
    >
      <path
        id="Icon_ionic-logo-youtube"
        data-name="Icon ionic-logo-youtube"
        d="M31.215,9.7a4.771,4.771,0,0,0-4.542-4.984c-3.4-.16-6.868-.221-10.409-.221h-1.1c-3.535,0-7.009.061-10.409.221a4.781,4.781,0,0,0-4.536,5C.061,11.9-.006,14.087,0,16.271s.061,4.37.209,6.561a4.787,4.787,0,0,0,4.536,5c3.572.166,7.236.239,10.961.233q5.6.018,10.961-.233a4.788,4.788,0,0,0,4.542-5c.147-2.191.215-4.376.209-6.567Q31.435,12.988,31.215,9.7ZM12.7,22.292V10.232l8.9,6.027Z"
        transform="translate(0 -4.5)"
        fill="#9191a6"
      />
    </svg>
  );
};

export const ArchitectureIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="77.576"
      height="77.577"
      viewBox="0 0 77.576 77.577"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_23"
            data-name="Rectangle 23"
            width="77.576"
            height="77.577"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_23" data-name="Group 23" clipPath="url(#clipPath)">
        <path
          id="Path_76"
          data-name="Path 76"
          d="M5.45,72.711c.959-.011,1.918,0,2.876,0,1.691,0,2-.305,2-1.97V26.161h45.2v-2.61h-45.2v-.9c0-1.792.01-3.585,0-5.375a1.276,1.276,0,0,0-1.381-1.44c-1.337-.019-2.676-.037-4.012.01A5.126,5.126,0,0,0,.3,19.293c-.107.305-.2.615-.3.923v55.89a.768.768,0,0,1,.109.2,5.37,5.37,0,0,0,5.614,4.184c11.131-.039,22.259-.016,33.388-.016H40V77.886h-1.12q-16.7,0-33.39,0A2.65,2.65,0,0,1,2.585,75.27,2.612,2.612,0,0,1,5.45,72.711M2.581,70.487V21.539c0-2.178.954-3.128,3.142-3.129H7.677V69.971l-5.1.516"
          transform="translate(0 -13.249)"
          fill="#1b4a97"
        />
        <path
          id="Path_77"
          data-name="Path 77"
          d="M299.634,5.5c-.5-.536-1.021-1.048-1.545-1.558q-2.03-1.974-4.07-3.939h-.756c-.349.287-.724.547-1.042.863-6.839,6.828-13.633,13.7-20.531,20.469a11.919,11.919,0,0,0-3.6,5.859c-.222.948-.6,1.811.581,2.59-1.1,1.016-2.086,1.936-3.025,2.806.652.649,1.237,1.229,1.943,1.933L270.42,31.6a1.672,1.672,0,0,0,2.235.458c.8-.3,1.649-.489,2.425-.839a6.649,6.649,0,0,0,1.949-1.2Q288.118,19,299.152,7.927c.161-.161.326-.316.479-.485a1.273,1.273,0,0,0,0-1.944M270.913,28.5c-.685-.992.312-1.586.247-2.345.919.911,1.819,1.8,2.738,2.712-1.019.453-2.04,1-2.985-.367m5.349-1.474-3.168-3.191c1.6-1.6,3.324-3.324,4.991-4.992l3.171,3.194-4.994,4.989m7.039-7.076-3.131-3.137L293.656,3.332l3.15,3.118L283.3,19.955"
          transform="translate(-222.527)"
          fill="#1b4a97"
        />
        <path
          id="Path_78"
          data-name="Path 78"
          d="M153.522,154.777a34.1,34.1,0,0,1-2.306-2.834c-.708.568-1.345,1.078-2,1.6.725.923,1.4,1.782,2.115,2.693a2.543,2.543,0,0,1-.326.062c-5.5,0-11,.01-16.506-.018a1.273,1.273,0,0,1-.839-.472c-2.495-3.077-4.963-6.176-7.437-9.271-.115-.146-.2-.313-.38-.586h11.4v-2.521a2.664,2.664,0,0,0-.305-.042q-6.853,0-13.7-.011a1.759,1.759,0,0,0-1.446.813q-4.862,6.1-9.746,12.173a2.694,2.694,0,0,0-.617,1.8c.015,4.8.007,9.59.008,14.386,0,1.462.37,1.827,1.842,1.827q16.09,0,32.179,0h.828v-2.611H134.739V158.914H152.8v7.654h2.511a.929.929,0,0,0,.063-.2c.007-2.069-.117-4.15.052-6.206a6.375,6.375,0,0,0-1.9-5.387m-30.457-8.042c2.538,3.175,5.033,6.292,7.626,9.532H115.443l7.622-9.532m2.54,25.007h-5.091v-7.628H125.6Zm6.453.019h-3.8c-.013-.286-.034-.55-.034-.818,0-2.6,0-5.2,0-7.794,0-1.261-.425-1.681-1.675-1.683q-3.481-.007-6.963,0c-1.248,0-1.694.44-1.7,1.677q-.007,3.861,0,7.719v.878h-3.819V158.925h17.991Z"
          transform="translate(-93.336 -120.109)"
          fill="#1b4a97"
        />
        <path
          id="Path_79"
          data-name="Path 79"
          d="M258.2,216.8c-.2-.381-.414-.894-.75-1.027a2.385,2.385,0,0,0-1.332.148c-.192.05-.331.3-.492.458Q236,236,216.372,255.629c-.161.161-.4.3-.461.492a2.29,2.29,0,0,0-.183,1.323c.151.355.678.578,1.076.789.179.1.446.023.674.023h38.851c1.519,0,1.892-.365,1.892-1.857V217.472a1.623,1.623,0,0,0-.023-.674m-2.618,38.819H220.231q17.674-17.667,35.349-35.339Z"
          transform="translate(-180.67 -180.705)"
          fill="#1b4a97"
        />
        <path
          id="Path_80"
          data-name="Path 80"
          d="M294.322,256.187a1.272,1.272,0,0,0-1.407-1.412q-2.459-.027-4.916,0a1.281,1.281,0,0,0-1.412,1.344q-.044,2.532,0,5.067a1.252,1.252,0,0,0,1.344,1.321c.833.023,1.665,0,2.5,0v0c.807,0,1.613.01,2.42,0,1-.015,1.462-.441,1.475-1.41q.032-2.456,0-4.916m-2.642,3.692h-2.472v-2.486h2.472Z"
          transform="translate(-240.055 -213.414)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_22"
          data-name="Rectangle 22"
          width="2.485"
          height="18.006"
          transform="translate(67.278 19.426)"
          fill="#1b4a97"
        />
        <path
          id="Path_81"
          data-name="Path 81"
          d="M84.734,337.273v2.568c-1.357,0-2.663.032-3.967-.015a1.115,1.115,0,0,1-1.117-1.13c-.054-1.3-.016-2.6-.016-3.957h2.55v2.534Z"
          transform="translate(-66.699 -280.412)"
          fill="#1b4a97"
        />
        <path
          id="Path_82"
          data-name="Path 82"
          d="M84.846,95.583v2.559h-2.54V100.7H79.784c0-1.388-.044-2.74.019-4.085A1.087,1.087,0,0,1,80.938,95.6c1.281-.041,2.561-.013,3.908-.013"
          transform="translate(-66.822 -80.062)"
          fill="#1b4a97"
        />
        <path
          id="Path_83"
          data-name="Path 83"
          d="M350.039,336.195a1.466,1.466,0,0,0-.8-1.573,1.424,1.424,0,0,0-1.678.506q-6.2,6.218-12.411,12.413a1.437,1.437,0,0,0-.526,1.673c.287.69.885.815,1.56.813,4.035-.008,8.071,0,12.106,0,1.29,0,1.737-.445,1.74-1.722,0-2.017,0-4.035,0-6.052s-.008-4.036,0-6.054m-2.626,11.2h-8.024c2.628-2.621,5.369-5.359,8.024-8.01Z"
          transform="translate(-280.228 -280.217)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const LandScapeIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="78.989"
      height="79"
      viewBox="0 0 78.989 79"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_24"
            data-name="Rectangle 24"
            width="78.989"
            height="79"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_27" data-name="Group 27" clipPath="url(#clipPath)">
        <path
          id="Path_84"
          data-name="Path 84"
          d="M74.967,61.16c-1.91-.008-3.82-.015-5.733.006-.432,0-.6-.149-.817-.532a6.913,6.913,0,0,0-1.644-2.18,16.559,16.559,0,0,0-3.07-1.429v-8.49c.132,0,.162-.011.181,0,.091.051.183.106.274.16a6.072,6.072,0,0,0,6.767-.023,6.222,6.222,0,0,0,2.94-6.122,1.017,1.017,0,0,1,.289-.719,6.336,6.336,0,0,0,.581-9.23.868.868,0,0,1-.115-.738,6.29,6.29,0,0,0-.8-6.471,1.178,1.178,0,0,1-.132-.853A6.385,6.385,0,0,0,68.8,16.681a1.227,1.227,0,0,1-.717-.5c-2.733-4.625-8.587-4.627-11.315,0a1.148,1.148,0,0,1-.64.489A6.341,6.341,0,0,0,51.2,24.611a1.024,1.024,0,0,1-.057.659c-.4.74-.844,1.455-1.281,2.193-4.091-3.07-7.975-2.555-11.7,1.1-.323-3.869-3.552-5.577-5.7-8.217h5.765c0-.613-.04-1.168.006-1.715A4.533,4.533,0,0,0,36.08,14.32,30.473,30.473,0,0,1,28.294,6.1c-.893-1.376-1.651-2.84-2.444-4.28A3.175,3.175,0,0,0,22.9,0a3.121,3.121,0,0,0-2.874,1.808c-.149.281-.289.566-.434.851A30.974,30.974,0,0,1,9.913,14.192c-2.321,1.642-2.453,3.74-2.193,6.2h5.694c-.268.289-.434.481-.613.662-1.064,1.074-2.163,2.119-3.191,3.227A7.722,7.722,0,0,0,7.7,30.616h5.782c-1.31,1.3-2.5,2.442-3.646,3.616A7.767,7.767,0,0,0,7.69,40.767H21.657v5.061c-3.472.342-5.324,1.942-6.269,5.28-.068.238-.332.436-.536.615a13.343,13.343,0,0,0-2.076,1.81c-1.8,2.423-1.7,4.965-.134,7.564-2.331.468-3.557,1.693-3.72,3.678-.089,1.1-.5,1.474-1.632,1.481-1.193,0-2.389-.021-3.582.009a3.816,3.816,0,0,0,.085,7.63c2.172.032,4.346.006,6.526.006a1.962,1.962,0,0,1,.013.291A3.806,3.806,0,0,0,14.34,79Q38.9,79,63.467,79a3.829,3.829,0,1,0-.028-7.643c-1.193-.006-2.389.015-3.582-.013a1.19,1.19,0,0,1-1.219-1.051,1.129,1.129,0,0,1,.734-1.347,2.813,2.813,0,0,1,1.01-.134c4.856-.009,9.713,0,14.571-.009a3.826,3.826,0,1,0,.013-7.641M64.7,60.137a2.8,2.8,0,0,1,1.017.968H48.956l-.1-.164c.383-.283.732-.719,1.159-.819.915-.219.993-.738.974-1.553a3.77,3.77,0,0,1,4.188-3.761,3.988,3.988,0,0,1,2.906,1.876,1.814,1.814,0,0,0,.942.67,2.678,2.678,0,0,1,2.034,1.912c.117.4.234.808.377,1.3,1.083-.328,2.117-1.059,3.265-.428M48.545,57.272a3.543,3.543,0,0,1-.7,1.142c-.649.849-1.325,1.674-1.91,2.408V53.4c3.089-.836,4.344-1.855,6.875-5.565a6.428,6.428,0,0,0,8.3.63V55.6a13.337,13.337,0,0,1-1.544-1.183,6.385,6.385,0,0,0-11.025,2.85m4.716-30.525c.364-.381.783-.708,1.208-1.089-.2-.4-.423-.791-.606-1.2a3.754,3.754,0,0,1,3.51-5.331c.879.03,1.217-.2,1.425-1.064a3.758,3.758,0,0,1,7.262,0c.211.868.555,1.091,1.429,1.064a3.762,3.762,0,0,1,3.5,5.344c-.174.383-.385.751-.617,1.2a4.6,4.6,0,0,1,2.251,3.45c.085,1.6-.925,2.646-1.908,3.795,1.723.868,3.2,1.914,3.17,4.042-.026,2.074-1.344,3.18-3.187,3.884.143.415.268.783.4,1.149a3.617,3.617,0,0,1-1.013,4.133,3.551,3.551,0,0,1-4.065.681A3.924,3.924,0,0,1,63.68,43.3a6.636,6.636,0,0,1,1.987-5.873,36.905,36.905,0,0,0,2.85-3.51l-1.983-1.587c-.917,1.14-1.8,2.229-2.8,3.474V22.967H61.176v7.8c-1.032-1.278-1.906-2.363-2.853-3.535-.647.515-1.278,1.019-1.983,1.583a34.913,34.913,0,0,0,2.6,3.218,7.189,7.189,0,0,1,2.246,6.341c-.189,1.651-.017,3.34-.045,5.012a3.819,3.819,0,0,1-2.606,3.555,3.729,3.729,0,0,1-4.193-1.3,1.441,1.441,0,0,1-.238-1.061,18.232,18.232,0,0,0-1.683-14,3.754,3.754,0,0,1,.834-3.827M39.015,31.712a9.778,9.778,0,0,1,1.71-2.078,5.442,5.442,0,0,1,7.69-.057,11.248,11.248,0,0,1,3.4,6.254,15.55,15.55,0,0,1-1.325,10.9,7.663,7.663,0,0,1-4.576,4.044c-.021-.264-.051-.459-.051-.655,0-2.761-.017-5.522.017-8.283a2.017,2.017,0,0,1,.415-1.127c1.412-1.825,2.867-3.62,4.378-5.514-.685-.551-1.319-1.059-1.978-1.591-.93,1.155-1.808,2.244-2.8,3.469V33.179h-2.55v9.445l-.166.077c-.872-1.289-1.746-2.578-2.642-3.9l-2.1,1.4c.283.428.54.817.8,1.206,1.161,1.744,2.3,3.506,3.5,5.224a2.954,2.954,0,0,1,.589,1.991c-.047.683-.009,1.374-.009,2.125a5.52,5.52,0,0,1-2.776-1.555,11.819,11.819,0,0,1-3.333-6.811,15.145,15.145,0,0,1,1.806-10.666m-6.5,19.257a1.259,1.259,0,0,1-.921-.332,6.6,6.6,0,0,0-4.361-2.214,1.461,1.461,0,0,1-.693-.266c-.676-.5-1.334-1.032-1.978-1.574a.886.886,0,0,1-.34-.536c-.026-1.721-.015-3.444-.015-5.222H34.38c.815,5.718,2.693,10.674,8.907,12.667V61.1H38.394a17.077,17.077,0,0,0,.921-2.382,6.376,6.376,0,0,0-6.8-7.749m2.827-17.481c-.211-.191-.366-.33-.517-.474-.774-.749-1.549-1.5-2.459-2.382h4.261c-.415.921-.827,1.838-1.285,2.857m-25.092,4.7a11.506,11.506,0,0,1,1.2-1.921c1.757-1.844,3.574-3.631,5.388-5.422a1.192,1.192,0,0,1,.7-.262c.5-.04,1-.013,1.532-.013V28.066H10.253A9.785,9.785,0,0,1,11.336,26.2c1.812-1.9,3.682-3.752,5.55-5.6a1.2,1.2,0,0,1,.715-.219c.47-.034.944-.011,1.461-.011v-2.5h-8.77c-.062-.079-.121-.157-.181-.234a8.082,8.082,0,0,1,1.027-1.106A35.94,35.94,0,0,0,20.47,6.3c.606-1,1.1-2.057,1.7-3.059a1.3,1.3,0,0,1,.793-.63c.225-.021.593.328.725.6A36.43,36.43,0,0,0,34.952,16.7a5.378,5.378,0,0,1,.783.906c-.051.074-.1.149-.151.223H26.8v2.459c.066.021.168.089.255.074a3.151,3.151,0,0,1,3.067,1.327c1.266,1.393,2.68,2.653,3.965,4.029a18.579,18.579,0,0,1,1.487,2.087c-.057.064-.115.128-.174.191h-8.6v2.482c.068.032.117.077.157.07a3.29,3.29,0,0,1,3.208,1.381,37.953,37.953,0,0,0,3.55,3.542,2.252,2.252,0,0,1,.649,2.712Zm6.992,15.373c.553-.113.638-.374.623-.872A3.841,3.841,0,0,1,20.47,48.6a3.777,3.777,0,0,1,4.5,1.789,1.2,1.2,0,0,0,1.415.623,3.614,3.614,0,0,1,3.7,1.949c.206.368.383.751.615,1.206.485-.177.9-.349,1.327-.476a3.757,3.757,0,0,1,4.3,1.576,3.959,3.959,0,0,1-.311,4.595,3.149,3.149,0,0,1-2.931,1.327c-5.222-.079-10.449-.055-15.673-.011a2.744,2.744,0,0,1-2.051-.872,3.863,3.863,0,0,1,1.878-6.745M74.482,66.255c-4.59,0-9.187.121-13.771-.045-2.836-.1-5.241,1.859-4.5,5.133H53.559V73.9h9.485c.213,0,.425-.009.636.006a1.271,1.271,0,1,1-.036,2.54c-.211.013-.423,0-.636,0H14.682c-1.329,0-1.914-.374-1.938-1.242-.023-.887.6-1.306,1.951-1.308h6.9V71.354H20.76q-8.121,0-16.241,0c-.238,0-.479.013-.717-.006a1.269,1.269,0,0,1-1.249-1.285,1.245,1.245,0,0,1,1.285-1.247c1.14-.03,2.282-.009,3.423-.011a3.842,3.842,0,0,0,4.205-3.81A1.283,1.283,0,0,1,12.8,63.709c.213-.011.425,0,.638,0H74.505c1.317,0,1.912.383,1.934,1.244.021.887-.606,1.3-1.957,1.3"
          transform="translate(0 0)"
          fill="#1b4a97"
        />
        <path
          id="Path_85"
          data-name="Path 85"
          d="M114.636,315.375V317.9c-1.632,0-3.248.083-4.85-.026a3,3,0,0,1-2.71-2.8c-.068-.764-.379-1-1.1-.985-1.244.036-2.493.009-3.74.006-.053,0-.1-.015-.251-.034v-2.444c1.693,0,3.389-.119,5.058.036a2.91,2.91,0,0,1,2.521,2.787c.062.73.374.957,1.059.942,1.321-.028,2.644-.008,4.016-.008"
          transform="translate(-80.288 -245.297)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const FurnitureIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="96.783"
      height="100.043"
      viewBox="0 0 96.783 100.043"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_32"
            data-name="Rectangle 32"
            width="96.783"
            height="100.043"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_30" data-name="Group 30" clipPath="url(#clipPath)">
        <path
          id="Path_86"
          data-name="Path 86"
          d="M83.818,225.776A11.29,11.29,0,0,0,61.3,227.01c-.03,1.807,0,3.617,0,5.529A76.038,76.038,0,0,0,41.954,230.2a76.764,76.764,0,0,0-19.375,2.327c0-1.761.019-3.372-.005-4.982a17.366,17.366,0,0,0-.164-2.305,11.2,11.2,0,0,0-8.95-9.346,11.284,11.284,0,0,0-10.665,18.5,11.509,11.509,0,0,0,6.884,3.779c0,2.225-.022,4.4.005,6.58a5.794,5.794,0,0,0,2.448,4.958,26.379,26.379,0,0,0,4,1.858c0,1.225-.016,2.734.005,4.242a1.624,1.624,0,0,0,1.81,1.81c1.411.022,2.823-.024,4.234.016a1.99,1.99,0,0,0,2.05-1.3c.7-1.489,1.487-2.936,2.184-4.422a1.155,1.155,0,0,1,1.225-.759q14.313.032,28.629,0a1.153,1.153,0,0,1,1.207.786c.716,1.516,1.5,3,2.23,4.514a1.893,1.893,0,0,0,1.918,1.177c1.312-.03,2.621-.005,3.932-.008,1.694,0,2.192-.514,2.195-2.243,0-1.4,0-2.79,0-4.161,4.215-.493,6.448-3,6.453-7.1V238.19c.482-.119.87-.207,1.252-.31a11.325,11.325,0,0,0,8.365-12.1M21.725,254.047c-.132.224-.6.3-.926.339a11.307,11.307,0,0,1-1.4.016v-3.159h3.757c-.487.986-.9,1.926-1.427,2.8m42.755.353c-.593,0-1.182.035-1.764-.019a.878.878,0,0,1-.6-.38c-.477-.87-.9-1.769-1.4-2.761h3.762Zm16.165-27.137a8.086,8.086,0,0,1-7.67,7.767c-1.524.086-2,.587-2,2.141,0,2.421.008,4.84,0,7.258a3.237,3.237,0,0,1-3.517,3.515q-25.5.008-51,0a3.263,3.263,0,0,1-3.552-3.582c-.005-2.419,0-4.837,0-7.258-.005-1.473-.506-1.993-1.966-2.074a8.065,8.065,0,1,1,8.392-8.521c.086,2.146.048,4.3,0,6.45a1.173,1.173,0,0,1-.622.811c-1.08.512-2.2.935-3.391,1.425.563,1,1.05,1.872,1.476,2.631a73.083,73.083,0,0,1,50.3-.005c.4-.708.891-1.578,1.468-2.6-1.347-.576-2.653-1.139-3.868-1.662a61.319,61.319,0,0,1,.065-7.967,7.884,7.884,0,0,1,8.6-6.655,8.1,8.1,0,0,1,7.293,8.327"
          transform="translate(0 -157.596)"
          fill="#1b4a97"
        />
        <path
          id="Path_87"
          data-name="Path 87"
          d="M194.6,0q-21.977,0-43.957,0c-.334,0-.671-.005-1.007.013a6.512,6.512,0,0,0-5.909,7.994H146.8c0-.323,0-.584,0-.848.019-2.761,1.185-3.932,3.911-3.932q9.579,0,19.154,0h1.177V37.053h3.17V3.228h.94q9.829,0,19.661,0a3.272,3.272,0,0,1,3.606,3.63q0,39.934,0,79.863a3.269,3.269,0,0,1-3.612,3.63q-6.5.008-13,0h-1.048v3.227c.986,0,1.9.057,2.8-.016a1.273,1.273,0,0,1,1.433.913c.681,1.495,1.462,2.946,2.184,4.425a1.849,1.849,0,0,0,1.839,1.139c1.376-.024,2.755,0,4.134-.008,1.5-.008,2.041-.563,2.05-2.085.005-1.438,0-2.876,0-4.3,4.4-.633,6.453-3.006,6.453-7.366V7.026c0-4.374-2.661-7.024-7.04-7.024m-2.7,96.682c-2.136.409-2.658-.024-3.628-3.051H191.9Z"
          transform="translate(-104.859 0)"
          fill="#1b4a97"
        />
        <path
          id="Path_88"
          data-name="Path 88"
          d="M71.407,53.533q-.776-9.086-1.543-18.171c-.129-1.541-.611-2.009-2.147-2.009q-5.644-.008-11.287,0H55.3V30.185h-3.24V33.35H50.844q-5.644,0-11.287,0c-1.271,0-1.883.5-1.98,1.646q-.8,9.389-1.584,18.775c-.124,1.519.5,2.16,2.041,2.163q6.448.008,12.9,0h1.185v3.181H55.36V55.938H69.217c1.791,0,2.343-.619,2.19-2.405m-32.071-.881c.447-5.368.889-10.668,1.333-16.019H66.745c.447,5.346.886,10.649,1.333,16.019Z"
          transform="translate(-26.288 -22.055)"
          fill="#1b4a97"
        />
        <path
          id="Path_89"
          data-name="Path 89"
          d="M100.421,164.233H97.2v-4.312c0-1.177.011-2.354,0-3.531a3.231,3.231,0,0,0-3.426-3.4q-9.478-.016-18.955-.005H42.955c-2.6,0-3.827,1.22-3.83,3.813q-.008,3.579-.013,7.159a1.277,1.277,0,0,1-.065.256H35.969c0-3-.213-6,.057-8.955a6.171,6.171,0,0,1,6.326-5.492q25.811-.02,51.619,0a6.394,6.394,0,0,1,6.442,6.391c.038,2.653.008,5.305.008,8.074"
          transform="translate(-26.223 -109.422)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_25"
          data-name="Rectangle 25"
          width="3.116"
          height="3.1"
          transform="translate(32.323 50.072)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_26"
          data-name="Rectangle 26"
          width="3.119"
          height="3.103"
          transform="translate(48.434 50.088)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_27"
          data-name="Rectangle 27"
          width="3.119"
          height="3.1"
          transform="translate(24.238 58.157)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_28"
          data-name="Rectangle 28"
          width="3.108"
          height="3.103"
          transform="translate(40.392 58.132)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_29"
          data-name="Rectangle 29"
          width="3.1"
          height="3.119"
          transform="translate(56.527 58.146)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_30"
          data-name="Rectangle 30"
          width="3.095"
          height="3.113"
          transform="translate(32.315 66.199)"
          fill="#1b4a97"
        />
        <rect
          id="Rectangle_31"
          data-name="Rectangle 31"
          width="3.135"
          height="3.086"
          transform="translate(48.429 66.212)"
          fill="#1b4a97"
        />
        <path
          id="Path_90"
          data-name="Path 90"
          d="M28.835,239.645a4.833,4.833,0,1,0,4.8,4.81,4.853,4.853,0,0,0-4.8-4.81m-.065,6.442a1.608,1.608,0,1,1,1.64-1.554,1.621,1.621,0,0,1-1.64,1.554"
          transform="translate(-17.516 -175.103)"
          fill="#1b4a97"
        />
        <path
          id="Path_91"
          data-name="Path 91"
          d="M256.444,239.645a4.833,4.833,0,1,0,4.8,4.818,4.851,4.851,0,0,0-4.8-4.818m.019,6.442a1.608,1.608,0,1,1,1.549-1.643,1.623,1.623,0,0,1-1.549,1.643"
          transform="translate(-183.82 -175.103)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const OuterDesignIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="89.408"
      height="89.467"
      viewBox="0 0 89.408 89.467"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_33"
            data-name="Rectangle 33"
            width="89.408"
            height="89.467"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_33" data-name="Group 33" clipPath="url(#clipPath)">
        <path
          id="Path_92"
          data-name="Path 92"
          d="M89.387,47.676a4.08,4.08,0,0,0-2.182-3.691,1.183,1.183,0,0,1-.7-1.248q.027-12.252.012-24.509v-.881c1.017.047,1.9.089,2.821.124V5.968Q47.549,2.978,5.846,0V11.539c.964.077,1.875.148,2.774.225V34.735H2.907c0,2.8-.012,5.5.006,8.2a.91.91,0,0,1-.562.97A4.17,4.17,0,0,0,.027,47.777c-.012.934-.024,1.863,0,2.8A4.121,4.121,0,0,0,2.28,54.312a1.043,1.043,0,0,1,.633,1.106q-.027,6.716,0,13.426a.973.973,0,0,1-.6,1.035A4.033,4.033,0,0,0,.038,73.51c-.053,2.011-.047,4.022-.006,6.033a4.306,4.306,0,0,0,4.146,4.181c.568.024,1.136.006,1.632.006.449.988.864,1.9,1.313,2.9H.08v2.833H86.513V88.29q0-16.395-.012-32.8a1.114,1.114,0,0,1,.651-1.189,4.106,4.106,0,0,0,2.236-3.75c.024-.958.03-1.922,0-2.88M8.721,3.1Q47.587,5.867,86.46,8.647v5.761Q47.558,11.631,8.721,8.86ZM83.562,17.093v26.2H49.1V14.632c11.5.822,22.948,1.638,34.463,2.46M11.6,34.694V11.953l34.5,2.466v28.9h-5.69V34.694ZM37.435,43.3H34.667V37.616h2.768Zm-5.755.047H28.924V37.663h2.756Zm-5.755-.053h-2.78V37.639h2.78Zm-5.772.024H17.385V37.633h2.768Zm-5.761-.024h-2.78V37.639h2.78Zm-8.529-5.66h2.75v5.678H5.864ZM13,86.617a4.324,4.324,0,1,1,4.318-4.288A4.342,4.342,0,0,1,13,86.617m12.929-.041H18.894c.426-.946.84-1.863,1.266-2.809h5.767ZM25.92,69.258H19.361a12.729,12.729,0,0,1,6.559-2.7Zm.006-5.631c-5.7.639-9.794,3.673-12.828,8.564H25.908v8.617h-5.8c-1.13-3.626-3.5-5.814-7.411-5.678-3.608.124-5.79,2.271-6.819,5.69-.148.012-.3.024-.444.03-2.23.047-2.531-.26-2.531-2.514,0-1.467-.012-2.939,0-4.412.012-1.183.526-1.709,1.7-1.721,1.26-.012,2.525-.047,3.785.012a1.629,1.629,0,0,0,1.65-.869A22.831,22.831,0,0,1,25.2,61.114c.225-.047.461-.059.727-.089Zm.012-6.08c-.024.213-.408.526-.668.574a24.923,24.923,0,0,0-11.989,5.406,29.178,29.178,0,0,0-4.436,4.566,2.636,2.636,0,0,1-3,1.147V54.933H25.967c0,.893.047,1.757-.03,2.614M48.992,86.569H28.924V54.963H48.992Zm17.276.006h-8.54V63.621h8.54Zm11.533,0h-8.54V63.621H77.8Zm5.767-.012h-2.8V60.735H54.788V86.569h-2.8V54.963H83.568Zm2.939-36.078a1.448,1.448,0,0,1-1.532,1.526c-.237.012-.479.006-.722.006H5.154c-1.9,0-2.247-.355-2.247-2.259,0-.692-.03-1.384.006-2.07A1.427,1.427,0,0,1,4.35,46.251c.266-.018.538-.006.81-.006H84.348c1.774,0,2.165.39,2.165,2.165,0,.692.018,1.384-.006,2.076"
          transform="translate(0)"
          fill="#1b4a97"
        />
        <path
          id="Path_93"
          data-name="Path 93"
          d="M24.475,38.054H35.9V29.52H24.475Zm8.57-2.88H27.373V32.4h5.672Z"
          transform="translate(-9.999 -12.061)"
          fill="#1b4a97"
        />
        <path
          id="Path_94"
          data-name="Path 94"
          d="M53.725,38.06H65.146V29.52H53.725Zm8.57-2.874H56.611V32.418h5.684Z"
          transform="translate(-21.95 -12.061)"
          fill="#1b4a97"
        />
        <path
          id="Path_95"
          data-name="Path 95"
          d="M87.865,54.514H99.28V34.44H87.865ZM96.4,51.627H90.745V37.32H96.4Z"
          transform="translate(-35.898 -14.071)"
          fill="#1b4a97"
        />
        <path
          id="Path_96"
          data-name="Path 96"
          d="M117.135,54.454h11.421V34.38H117.135Zm8.523-2.851H120V37.3h5.66Z"
          transform="translate(-47.857 -14.046)"
          fill="#1b4a97"
        />
        <path
          id="Path_97"
          data-name="Path 97"
          d="M53.725,109.2h14.3V97.78h-14.3Zm11.421-2.88h-8.5v-5.69h8.5Z"
          transform="translate(-21.95 -39.949)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const InnerDesignIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="118.193"
      height="103.178"
      viewBox="0 0 118.193 103.178"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_64"
            data-name="Rectangle 64"
            width="118.193"
            height="103.178"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_91" data-name="Group 91" clipPath="url(#clipPath)">
        <path
          id="Path_151"
          data-name="Path 151"
          d="M22.375,323.757a1.788,1.788,0,0,1-1.52,1.779,5.467,5.467,0,0,1-1.147.077c-5.655.006-11.306-.018-16.96.022A2.926,2.926,0,0,1,0,324.364V322.98a2.876,2.876,0,0,1,2.726-1.326c5.651.037,11.306.015,16.96.025a4.491,4.491,0,0,1,1.366.148,1.783,1.783,0,0,1,1.323,1.93"
          transform="translate(0 -222.483)"
          fill="#1b4a97"
        />
        <path
          id="Path_152"
          data-name="Path 152"
          d="M195.46,195.76a8.592,8.592,0,0,1-8.1,8.389c-3.453.163-6.922.083-10.381.062-1.492-.009-2.164-.771-2.174-2.374-.019-3.576-.006-7.153-.006-10.732v-1.387h-1.585q-19.674,0-39.344,0a7.334,7.334,0,0,1-1.606-.1,1.921,1.921,0,0,1-.009-3.737,6.2,6.2,0,0,1,1.375-.1q21.117-.009,42.23,0c2.34,0,2.867.509,2.877,2.833.015,3.425.006,6.848.009,10.27v1.357c3,0,5.809.1,8.6-.034a4.633,4.633,0,0,0,4.19-4.612q.079-8.708-.006-17.42a4.809,4.809,0,0,0-4.767-4.7c-1-.04-2-.028-3-.009a4.9,4.9,0,0,0-5,4.831c-.04.651.006,1.31-.055,1.958a1.867,1.867,0,0,1-1.881,1.8,1.828,1.828,0,0,1-1.945-1.6c-.734-5.753,2.4-9.616,6.789-10.662.8-.191,1.058-.45,1.048-1.267-.04-3.808.009-7.615-.025-11.42-.037-4.286-2.759-6.99-7.017-7q-11.539-.018-23.077,0H151.42v21.03c0,.305.009.614,0,.922a1.964,1.964,0,1,1-3.919.049c-.031-1.036-.009-2.075-.009-3.114V150.1h-1.236q-11.654,0-23.309,0c-4.545,0-7.208,2.689-7.227,7.261-.006,1.347.028,2.695-.025,4.039a1.847,1.847,0,0,1-1.862,1.936,1.815,1.815,0,0,1-2-1.8,37.226,37.226,0,0,1,.277-7.119c.962-5.035,5.26-8.244,10.621-8.251q18.92-.023,37.846-.006,7.441,0,14.882,0c6.749.012,11.164,4.44,11.183,11.22.012,3.576,0,7.153,0,10.729v1.3c.78.136,1.5.219,2.192.392a8.717,8.717,0,0,1,6.626,8.189c.074,5.92.083,11.846,0,17.765"
          transform="translate(-77.328 -101.093)"
          fill="#1b4a97"
        />
        <path
          id="Path_153"
          data-name="Path 153"
          d="M149.732,254.735a1.78,1.78,0,0,1-1.517,1.785,8.008,8.008,0,0,1-1.492.08q-13.324.009-26.651,0c-8.614,0-17.232-.123-25.843.043a9.229,9.229,0,0,1-9.755-9.811c.188-5.186.034-10.381.04-15.573.009-5.593,3.752-9.351,9.317-9.364a26.5,26.5,0,0,1,3.57.08,8.773,8.773,0,0,1,7.8,8.842c.068,3.536.025,7.076.009,10.615-.009,1.461-.783,2.356-1.967,2.365s-1.955-.86-1.961-2.334c-.019-3.345,0-6.69-.009-10.036-.009-3.681-1.945-5.6-5.642-5.605-.808,0-1.616-.025-2.42.012a4.818,4.818,0,0,0-4.739,4.733q-.1,8.708,0,17.42a4.766,4.766,0,0,0,4.674,4.649c.462.025.925.015,1.384.015q26.074,0,52.149.009a6.448,6.448,0,0,1,1.711.151,1.753,1.753,0,0,1,1.338,1.918"
          transform="translate(-58.424 -153.47)"
          fill="#1b4a97"
        />
        <path
          id="Path_154"
          data-name="Path 154"
          d="M76.28,9.285A1.931,1.931,0,0,1,73.663,9.1c-.351-.351-.651-.758-.98-1.135C67.114,1.562,54.267,2.456,51,12.479a15.033,15.033,0,0,0-.635,4.529c-.046,12.422-.028,24.844-.028,37.266h.1q0,18.924,0,37.846a9.306,9.306,0,0,1-.059,1.5,1.925,1.925,0,0,1-3.761.163,5.01,5.01,0,0,1-.117-1.255q-.046-38.076-.077-76.148A16.209,16.209,0,0,1,62.153.023,16.469,16.469,0,0,1,76,5.783,6.441,6.441,0,0,1,76.7,6.7a1.944,1.944,0,0,1-.416,2.587"
          transform="translate(-32.108 0)"
          fill="#1b4a97"
        />
        <path
          id="Path_155"
          data-name="Path 155"
          d="M131.357,59.8a13.78,13.78,0,0,0-26.093-5.9c-1.452,2.864-1.5,5.9-1.443,8.987.037,1.992.629,2.608,2.639,2.611,3.687.009,7.375,0,11.062,0,3.8,0,7.606.012,11.411-.006,1.76-.009,2.417-.7,2.43-2.467.006-1.076.009-2.152-.006-3.228m-3.965,1.686H107.823c-.351-4.067.962-7.363,4.344-9.589a9.294,9.294,0,0,1,10.652-.129c3.524,2.2,4.868,5.565,4.572,9.718"
          transform="translate(-71.803 -32.009)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const SitePlanningIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="99.16"
      height="98.09"
      viewBox="0 0 99.16 98.09"
      {...rest}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_63"
            data-name="Rectangle 63"
            width="99.16"
            height="98.09"
            fill="#1b4a97"
          />
        </clipPath>
      </defs>
      <g id="Group_89" data-name="Group 89" clipPath="url(#clipPath)">
        <path
          id="Path_142"
          data-name="Path 142"
          d="M188.806.1q-7.122,0-14.245,0,7.125,0,14.245.006,1.665,0,3.332,0-1.665,0-3.332,0"
          transform="translate(-139.264 -0.075)"
          fill="#1b4a97"
        />
        <path
          id="Path_143"
          data-name="Path 143"
          d="M95.972,9.347c-3.945-5.979-9.5-9.239-16.71-9.3C73.8,0,68.336-.005,62.874,0q-5,.006-10,.016-1.665,0-3.332,0-7.122,0-14.245,0-7.838,0-15.677.03a18.618,18.618,0,0,0-4.279.538A20.3,20.3,0,0,0,0,20.5C.089,39.571.026,58.643.043,77.715A20.015,20.015,0,0,0,20.5,98.085q28.96.012,57.922-.012a25.382,25.382,0,0,0,3.913-.319,20.237,20.237,0,0,0,16.82-19.715q0-28.808,0-57.619A19.683,19.683,0,0,0,95.972,9.347m-.69,68.686A16.43,16.43,0,0,1,80.932,94.09a24.438,24.438,0,0,1-2.718.16q-28.86.015-57.716.01A16.531,16.531,0,0,1,3.988,80.018,20.4,20.4,0,0,1,3.832,77.1Q3.814,63,3.826,48.9h0q0-14.049,0-28.1A16.376,16.376,0,0,1,7.692,9.713,16.094,16.094,0,0,1,20.431,3.794q29.16-.006,58.321,0a16.466,16.466,0,0,1,16,12.236,15.472,15.472,0,0,1,.512,3.884q.049,29.06.02,58.118"
          transform="translate(0 0)"
          fill="#1b4a97"
        />
        <path
          id="Path_144"
          data-name="Path 144"
          d="M265.6,246.218a2.248,2.248,0,0,1,.328-.2c2.014-.708,2.524-1.9,1.6-3.793-.639-1.306-1.288-2.608-1.941-3.929a2.317,2.317,0,0,1,.394-.182c2-.336,2.485-2.36,1.517-3.892-.552-.876-.94-1.854-1.405-2.784q-4.14-8.286-8.274-16.573a2.548,2.548,0,0,0-2.441-1.61q-10.513.006-21.025.006c-.956,0-1.654.52-1.569,1.191.111.882.722,1.07,1.537,1.064,3.874-.026,7.751-.032,11.625.014a1.529,1.529,0,0,1,1.2.617,1.977,1.977,0,0,1-.231,1.448,1.728,1.728,0,0,1-.989.748c-1.575.437-3.169.807-4.762,1.179-2.962.694-4.588,2.964-3.747,5.573a5.571,5.571,0,0,0,4.756,3.7,55.636,55.636,0,0,0,6.319.4c2.344.115,4.616.419,6.509,2.01a6.182,6.182,0,0,1,2.439,4.487h-1.377q-11.016,0-22.037,0c-.926,0-1.436.457-1.43,1.28.006.944.611,1.161,1.419,1.157,1.887-.012,3.773-.006,5.66-.006,7.413,0,14.826-.008,22.239.018.421,0,1.066.142,1.223.429.9,1.626,1.676,3.316,2.6,5.191h-1.458c-9.2,0-18.4.006-27.6-.022-.823,0-1.306.305-1.446,1.051-.113.607.633,1.183,1.458,1.215.338.012.673,0,1.011,0q12.081,0,24.16.016c.423,0,1.074.109,1.227.384.89,1.6,1.662,3.258,2.56,5.071H238.671c-.781,0-1.426.178-1.452,1.132-.028,1.023.659,1.076,1.432,1.076q13.446-.012,26.889,0a2.18,2.18,0,0,0,2.073-3.419c-.69-1.335-1.343-2.687-2.018-4.042m-5.838-10.608a9.174,9.174,0,0,0-5.411-7.5,14.456,14.456,0,0,0-5.751-1.231c-1.876-.111-3.761-.133-5.638-.263a4.284,4.284,0,0,1-2.966-1.533,1.669,1.669,0,0,1,.433-2.776,30.217,30.217,0,0,1,3.834-1.136c.936-.253,1.913-.388,2.825-.708a4.135,4.135,0,0,0,2.469-3.735c-.006-.362,0-.724,0-1.215,1.9,0,3.781-.022,5.654.028.231.008.528.366.663.629,1.219,2.392,2.41,4.8,3.609,7.2q2.942,5.893,5.882,11.787c.055.111.087.237.166.453Z"
          transform="translate(-185.559 -170.132)"
          fill="#1b4a97"
        />
        <path
          id="Path_145"
          data-name="Path 145"
          d="M127.726,152.7c-1.919.049-3.842.057-5.757-.02a1.69,1.69,0,0,1-1.114-.76c-.117-.18.156-.766.408-.993a1.711,1.711,0,0,1,1.035-.247c2.081-.022,4.159-.01,6.376-.01v-1.066q0-8.186,0-16.371a2.416,2.416,0,0,0-2.722-2.734q-8.59-.021-17.177,0c-1.812.006-2.645.88-2.645,2.687q0,8.183.006,16.369c0,.352.038.706.063,1.108,2.206,0,4.291.02,6.376-.01.839-.012,1.316.368,1.3,1.163-.016.764-.574.92-1.282.908-2.113-.036-4.228-.012-6.321-.012-.473,2.483.376,3.559,2.74,3.563q8.538.015,17.076.014a2.343,2.343,0,0,0,2.61-2.6c.012-.732-.194-1.013-.971-.993M110.67,141.518c.17-4.293,2.821-6.365,6.774-6.37a6.2,6.2,0,0,1,6.592,6.564,6.6,6.6,0,0,1-6.721,6.681,6.536,6.536,0,0,1-6.645-6.875"
          transform="translate(-84.668 -104.107)"
          fill="#1b4a97"
        />
        <path
          id="Path_146"
          data-name="Path 146"
          d="M90.8,274.979c-.861,2.613-1.765,5.211-2.657,7.811Q86.571,287.4,84.979,292c-.558,1.616-1.144,3.219-1.674,4.843-.3.93-.736,1.547-1.854,1.4-.6-.081-1.211,0-1.818-.02-.965-.038-1.413-.663-1.1-1.551,1.163-3.32,2.364-6.624,3.506-9.951,1.32-3.844,2.59-7.706,3.892-11.558.611-1.808,1.223-3.615,1.9-5.4a1.207,1.207,0,0,1,.859-.625c1-.081,2.012-.03,3.072-.03.56,2.186-.34,4.012-.954,5.876"
          transform="translate(-62.573 -214.676)"
          fill="#1b4a97"
        />
        <path
          id="Path_147"
          data-name="Path 147"
          d="M189.6,298.188a18.7,18.7,0,0,0-2.02,0c-.882.077-1.272-.4-1.525-1.136-1.12-3.268-2.263-6.525-3.375-9.795-1.32-3.876-2.615-7.761-3.929-11.639-.279-.827-.671-1.626-.872-2.469-.3-1.284-.483-2.6-.75-4.087a34.75,34.75,0,0,1,3.482.04,1.45,1.45,0,0,1,.9.853c.649,1.686,1.223,3.4,1.806,5.114,1.116,3.272,2.214,6.551,3.336,9.823,1.24,3.615,2.5,7.223,3.747,10.836a5.755,5.755,0,0,1,.307,1.165c.1.8-.2,1.308-1.106,1.29"
          transform="translate(-141.314 -214.642)"
          fill="#1b4a97"
        />
        <path
          id="Path_148"
          data-name="Path 148"
          d="M154.982,290.882c0,1.531-.388,1.913-1.9,1.923-.37,0-.74.006-1.11,0-1.163-.036-1.6-.447-1.6-1.6q-.012-10.7,0-21.406c0-.164.028-.33.051-.607.348-.026.611-.061.874-.063,1.175-.006,2.35,0,3.63,0,.02.439.055.8.055,1.155q.006,10.3,0,20.6"
          transform="translate(-119.962 -214.708)"
          fill="#1b4a97"
        />
        <path
          id="Path_149"
          data-name="Path 149"
          d="M134.947,88.374a7.021,7.021,0,0,1-1.913.936c-.038-.085-.077-.17-.115-.253h-.607c-1.252-.006-1.557-.3-1.589-1.523-.04-1.577-.35-1.887-1.895-1.887-1.887,0-3.775,0-5.662,0-1.053.006-1.434.38-1.506,1.448-.135,1.933-.164,1.961-2.06,1.959-.37,0-.742-.022-1.11,0a1.1,1.1,0,0,1-1.24-1.064c-.455-3.816,1.9-6.907,5.642-6.824,2.19.049,4.386.111,6.57-.018a5.6,5.6,0,0,1,5.724,5.7c0,.524.059,1.248-.239,1.525"
          transform="translate(-93.496 -64.735)"
          fill="#1b4a97"
        />
        <path
          id="Path_150"
          data-name="Path 150"
          d="M143.914,172.743a4.67,4.67,0,0,1-4.554-4.57c.142-2.524,1.955-4.608,4.594-4.4,2.4-.142,4.242,1.713,4.451,4.345a4.661,4.661,0,0,1-4.491,4.629"
          transform="translate(-111.176 -130.643)"
          fill="#1b4a97"
        />
      </g>
    </svg>
  );
};

export const ExperienceIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="67.37"
      height="77.751"
      viewBox="0 0 67.37 77.751"
      {...rest}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="1.417"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#12afe2" />
          <stop offset="0.646" stopColor="#1382c1" />
          <stop offset="1" stopColor="#160d6c" />
        </linearGradient>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_59"
            data-name="Rectangle 59"
            width="67.37"
            height="77.751"
            transform="translate(0 0)"
            fill="url(#linear-gradient)"
          />
        </clipPath>
      </defs>
      <g
        id="Group_66"
        data-name="Group 66"
        transform="translate(0 0)"
        clipPath="url(#clipPath)"
      >
        <path
          id="Path_120"
          data-name="Path 120"
          d="M57,13.17A12.927,12.927,0,0,0,43.83,0H13.23A12.944,12.944,0,0,0,0,13.21V56.76A12.941,12.941,0,0,0,13.22,69.97q13.68.015,27.37,0h.87c0-2.63.02-5.14-.02-7.65a1.6,1.6,0,0,0-.44-.89,18.137,18.137,0,0,1,14.42-30.3c.5.03,1,.1,1.59.16v-.88q0-8.61-.01-17.24M26.12,57.01q-6.48.015-12.95,0a2.6,2.6,0,1,1,.01-5.18H26.12a2.6,2.6,0,1,1,0,5.18m.6-12.95H13.2a2.6,2.6,0,1,1,.04-5.18q6.75-.015,13.51,0a2.6,2.6,0,1,1-.03,5.18m9.69-13.52a3.114,3.114,0,0,1-1.56.54q-10.935.045-21.86.01a2.586,2.586,0,1,1,.05-5.17c3.62-.01,7.23,0,10.85,0,3.64,0,7.28-.01,10.92,0a2.578,2.578,0,0,1,2.51,1.82,2.452,2.452,0,0,1-.91,2.8M46.46,16.5a2.632,2.632,0,0,1-2.63,1.64c-5.1.01-10.2,0-15.3,0-5.13,0-10.26.01-15.39,0a2.584,2.584,0,0,1-2.57-3.57,2.536,2.536,0,0,1,2.57-1.61H43.82a2.607,2.607,0,0,1,2.64,3.54"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_121"
          data-name="Path 121"
          d="M67.37,49.33A12.955,12.955,0,1,1,54.49,36.28,12.977,12.977,0,0,1,67.37,49.33"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_122"
          data-name="Path 122"
          d="M62.19,65.63v9.39a2.6,2.6,0,0,1-4.11,2.23c-1.06-.7-2.12-1.39-3.15-2.12a.739.739,0,0,0-1-.01c-1.01.72-2.05,1.38-3.08,2.07a2.551,2.551,0,0,1-2.82.24,2.6,2.6,0,0,1-1.39-2.54c.01-3.05,0-6.09,0-9.26a18.17,18.17,0,0,0,15.55,0"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  );
};

export const MusclesIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  return (
    <svg
      id="Group_53"
      data-name="Group 53"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="80.836"
      height="80.836"
      viewBox="0 0 80.836 80.836"
      {...rest}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="1.111"
          y1="0.883"
          x2="-0.062"
          y2="-0.039"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#12afe2" />
          <stop offset="0.646" stopColor="#1382c1" />
          <stop offset="1" stopColor="#160d6c" />
        </linearGradient>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_37"
            data-name="Rectangle 37"
            width="80.836"
            height="80.836"
            fill="url(#linear-gradient)"
          />
        </clipPath>
        <clipPath id="clipPath-2">
          <rect
            id="Rectangle_38"
            data-name="Rectangle 38"
            width="51.095"
            height="53.247"
            fill="url(#linear-gradient)"
          />
        </clipPath>
      </defs>
      <g id="Group_50" data-name="Group 50" transform="translate(0 0)">
        <g id="Group_49" data-name="Group 49" clipPath="url(#clipPath)">
          <path
            id="Path_114"
            data-name="Path 114"
            d="M40.419,2.423a37.992,37.992,0,0,0-26.865,64.86,37.993,37.993,0,1,0,53.729-53.73A37.763,37.763,0,0,0,40.419,2.423m0,78.413A40.429,40.429,0,0,1,0,40.418,40.429,40.429,0,0,1,40.419,0,40.427,40.427,0,0,1,80.836,40.418,40.427,40.427,0,0,1,40.419,80.836Z"
            transform="translate(0 0)"
            fill="url(#linear-gradient)"
          />
        </g>
      </g>
      <g id="Group_52" data-name="Group 52" transform="translate(12.59 11.234)">
        <g id="Group_51" data-name="Group 51" clipPath="url(#clipPath-2)">
          <path
            id="Path_115"
            data-name="Path 115"
            d="M62.034,50.166a28.516,28.516,0,0,1-2.075,2.387C47.345,63.565,37.45,63.018,33.781,62.273a5.518,5.518,0,0,0-2.8.164,23.257,23.257,0,0,1-3.55.844,9.407,9.407,0,0,1-7.547-1.872c-4.554-3.733-3.659-10.18-3.549-10.86,1.409-3.732,3.516-6.174,6.291-7.268,3.713-1.467,7.678-.176,9.425.569a11.537,11.537,0,0,0-1.485,5.856.757.757,0,0,0,.731.778h.023a.758.758,0,0,0,.753-.733,10.135,10.135,0,0,1,1.65-5.758c.022-.033.043-.055.065-.088,3.353-4.4,10.736-1.982,10.813-1.96a1.237,1.237,0,0,0,.218.044.766.766,0,0,0,.787-.733l.316-8.823a6.635,6.635,0,0,0-3.494-7.5,2.38,2.38,0,0,0-2.206-.032,3.281,3.281,0,0,1-2.283.022,3.539,3.539,0,0,0-3.976.635.84.84,0,0,1-.786.229,5.307,5.307,0,0,1-3.692-3.711,4.157,4.157,0,0,1,.076-2.65A9.32,9.32,0,0,1,35.3,13.461c7.1,1.763,13.379,7.148,13.434,7.193a27.167,27.167,0,0,1,3.156,3.393,1.1,1.1,0,0,0,.164.153,41.556,41.556,0,0,1,2.72,3.908.926.926,0,0,0,.087.22c.372.624.743,1.248,1.093,1.883a.789.789,0,0,0,.175.208c.688,1.248,1.4,2.639,2.086,4.182a.656.656,0,0,0,.076.317c.317.7.612,1.38.885,2.058a1,1,0,0,0,.164.252c.578,1.433,1.147,2.977,1.692,4.631.011.055.023.1.033.153.732,2.168,1.246,3.985,1.562,5.135a3.468,3.468,0,0,1-.59,3.021m2.053-3.415c-.317-1.171-.841-3.022-1.583-5.221a.638.638,0,0,0-.229-.328C60.582,36.012,56.4,24.714,50.905,20.664c-.382-.394-.776-.766-1.18-1.138-.273-.241-6.727-5.78-14.264-7.586a.627.627,0,0,0-.349,0,10.726,10.726,0,0,0-6.968,6.984,5.63,5.63,0,0,0-.1,3.623,6.759,6.759,0,0,0,4.717,4.708,2.357,2.357,0,0,0,2.218-.57,2.088,2.088,0,0,1,2.391-.35,4.79,4.79,0,0,0,3.55-.088.879.879,0,0,1,.808.033c1.562.8,3.3,2.486,2.687,5.944a.357.357,0,0,0-.01.109l-.284,7.9c-2.25-.559-7.9-1.467-11.195,2.332-1.758-.778-6.433-2.453-10.856-.7-3.211,1.259-5.624,4.018-7.186,8.211-.011.043-.023.076-.033.12-.066.318-1.431,7.871,4.074,12.381a10.7,10.7,0,0,0,6.8,2.365,11.559,11.559,0,0,0,1.944-.164,25.023,25.023,0,0,0,3.778-.9,3.919,3.919,0,0,1,2.01-.121c3.888.788,14.34,1.39,27.512-10.094a25.186,25.186,0,0,0,2.25-2.583,4.913,4.913,0,0,0,.863-4.335"
            transform="translate(-13.415 -11.906)"
            fill="url(#linear-gradient)"
          />
          <path
            id="Path_116"
            data-name="Path 116"
            d="M50.434,55.6a.754.754,0,0,0-1.027.307,10.26,10.26,0,0,1-3.058,3.3c-2.786,1.916-6.139,2.167-9.961.755a.758.758,0,0,0-.525,1.423,14.506,14.506,0,0,0,5.1.985,11.512,11.512,0,0,0,9.786-5.758.756.756,0,0,0-.317-1.007"
            transform="translate(-14.582 -14.361)"
            fill="url(#linear-gradient)"
          />
          <path
            id="Path_117"
            data-name="Path 117"
            d="M62.034,50.166a28.516,28.516,0,0,1-2.075,2.387C47.345,63.565,37.45,63.018,33.781,62.273a5.518,5.518,0,0,0-2.8.164,23.257,23.257,0,0,1-3.55.844,9.407,9.407,0,0,1-7.547-1.872c-4.554-3.733-3.659-10.18-3.549-10.86,1.409-3.732,3.516-6.174,6.291-7.268,3.713-1.467,7.678-.176,9.425.569a11.537,11.537,0,0,0-1.485,5.856.757.757,0,0,0,.731.778h.023a.758.758,0,0,0,.753-.733,10.135,10.135,0,0,1,1.65-5.758c.022-.033.043-.055.065-.088,3.353-4.4,10.736-1.982,10.813-1.96a1.237,1.237,0,0,0,.218.044.766.766,0,0,0,.787-.733l.316-8.823a6.635,6.635,0,0,0-3.494-7.5,2.38,2.38,0,0,0-2.206-.032,3.281,3.281,0,0,1-2.283.022,3.539,3.539,0,0,0-3.976.635.84.84,0,0,1-.786.229,5.307,5.307,0,0,1-3.692-3.711,4.157,4.157,0,0,1,.076-2.65A9.32,9.32,0,0,1,35.3,13.461c7.1,1.763,13.379,7.148,13.434,7.193a27.167,27.167,0,0,1,3.156,3.393,1.1,1.1,0,0,0,.164.153,41.556,41.556,0,0,1,2.72,3.908.926.926,0,0,0,.087.22c.372.624.743,1.248,1.093,1.883a.789.789,0,0,0,.175.208c.688,1.248,1.4,2.639,2.086,4.182a.656.656,0,0,0,.076.317c.317.7.612,1.38.885,2.058a1,1,0,0,0,.164.252c.578,1.433,1.147,2.977,1.692,4.631.011.055.023.1.033.153.732,2.168,1.246,3.985,1.562,5.135a3.468,3.468,0,0,1-.59,3.021m2.053-3.415c-.317-1.171-.841-3.022-1.583-5.221a.638.638,0,0,0-.229-.328C60.582,36.012,56.4,24.714,50.905,20.664c-.382-.394-.776-.766-1.18-1.138-.273-.241-6.727-5.78-14.264-7.586a.627.627,0,0,0-.349,0,10.726,10.726,0,0,0-6.968,6.984,5.63,5.63,0,0,0-.1,3.623,6.759,6.759,0,0,0,4.717,4.708,2.357,2.357,0,0,0,2.218-.57,2.088,2.088,0,0,1,2.391-.35,4.79,4.79,0,0,0,3.55-.088.879.879,0,0,1,.808.033c1.562.8,3.3,2.486,2.687,5.944a.357.357,0,0,0-.01.109l-.284,7.9c-2.25-.559-7.9-1.467-11.195,2.332-1.758-.778-6.433-2.453-10.856-.7-3.211,1.259-5.624,4.018-7.186,8.211-.011.043-.023.076-.033.12-.066.318-1.431,7.871,4.074,12.381a10.7,10.7,0,0,0,6.8,2.365,11.559,11.559,0,0,0,1.944-.164,25.023,25.023,0,0,0,3.778-.9,3.919,3.919,0,0,1,2.01-.121c3.888.788,14.34,1.39,27.512-10.094a25.186,25.186,0,0,0,2.25-2.583,4.913,4.913,0,0,0,.863-4.335"
            transform="translate(-13.415 -11.906)"
            fill="url(#linear-gradient)"
          />
          <path
            id="Path_118"
            data-name="Path 118"
            d="M50.434,55.6a.754.754,0,0,0-1.027.307,10.26,10.26,0,0,1-3.058,3.3c-2.786,1.916-6.139,2.167-9.961.755a.758.758,0,0,0-.525,1.423,14.506,14.506,0,0,0,5.1.985,11.512,11.512,0,0,0,9.786-5.758.756.756,0,0,0-.317-1.007"
            transform="translate(-14.582 -14.361)"
            fill="url(#linear-gradient)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ClockIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="70.71"
      height="70.71"
      viewBox="0 0 70.71 70.71"
      {...rest}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#12afe2" />
          <stop offset="0.646" stopColor="#1382c1" />
          <stop offset="1" stopColor="#160d6c" />
        </linearGradient>
      </defs>
      <path
        id="Icon_weather-time-11"
        data-name="Icon weather-time-11"
        d="M4.488,39.246A34.667,34.667,0,0,1,9.261,21.474a35.326,35.326,0,0,1,12.9-12.9A35.288,35.288,0,0,1,53.6,6.623a35.672,35.672,0,0,1,11.272,7.536,34.619,34.619,0,0,1,7.536,11.3A35.112,35.112,0,0,1,53.6,71.744a35.238,35.238,0,0,1-27.505,0,35.816,35.816,0,0,1-11.3-7.536A35.529,35.529,0,0,1,7.251,52.967,34.027,34.027,0,0,1,4.488,39.246Zm7.787,0a26.685,26.685,0,0,0,8.132,19.4,26.52,26.52,0,0,0,19.467,8.132,26.694,26.694,0,0,0,13.784-3.705A27.857,27.857,0,0,0,63.738,53.03a27.351,27.351,0,0,0,0-27.6A27.7,27.7,0,0,0,53.659,15.351a26.776,26.776,0,0,0-13.784-3.705A26.694,26.694,0,0,0,26.09,15.351,28.028,28.028,0,0,0,15.98,25.43,26.587,26.587,0,0,0,12.275,39.246ZM29.921,25.964a2.639,2.639,0,0,1,4.8-.659l2.449,4.082V18.334a2.606,2.606,0,1,1,5.212,0V39.277a2.574,2.574,0,0,1-2.606,2.606A2.406,2.406,0,0,1,37.3,40.219L30.2,27.942A2.448,2.448,0,0,1,29.921,25.964Z"
        transform="translate(-4.488 -3.828)"
        fill="url(#linear-gradient)"
      />
    </svg>
  );
};

export const EvolutionIcon: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="83.53"
      height="78.53"
      viewBox="0 0 83.53 78.53"
      {...rest}
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.5"
          x2="0.5"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#12afe2" />
          <stop offset="0.646" stopColor="#1382c1" />
          <stop offset="1" stopColor="#160d6c" />
        </linearGradient>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_61"
            data-name="Rectangle 61"
            width="83.53"
            height="78.53"
            fill="url(#linear-gradient)"
          />
        </clipPath>
      </defs>
      <g id="Group_68" data-name="Group 68" clipPath="url(#clipPath)">
        <path
          id="Path_123"
          data-name="Path 123"
          d="M72,52.78a49.192,49.192,0,0,1-2.76,6.19c2.08,2.47,4.26,5.07,6.38,7.6L65.53,76.66q-4.29-3.615-8.89-7.49c.71-.85,1.39-1.68,2.14-2.58,2.24,1.9,4.45,3.78,6.58,5.59,1.96-1.96,3.89-3.89,5.87-5.86-2-2.37-4.08-4.85-6.18-7.34a29.816,29.816,0,0,0,4.03-7.57c.4-1.15.74-2.33,1.03-3.51.12-.46.28-.61.74-.64,2.96-.24,5.91-.5,8.86-.76.16-.02.32-.05.52-.08V38.25c-1.6-.14-3.19-.3-4.78-.44-1.46-.13-2.92-.27-4.39-.34-.65-.03-.64-.46-.72-.87a30.638,30.638,0,0,0-2.99-8.67c-.43-.82-.91-1.61-1.43-2.5,2.11-2.5,4.26-5.04,6.35-7.52-1.97-1.97-3.89-3.89-5.86-5.85-2.18,1.89-4.43,3.81-6.64,5.78a1.009,1.009,0,0,1-1.51.12,27.81,27.81,0,0,0-10.24-4.49c-.54-.12-.61-.43-.65-.85-.24-2.66-.48-5.31-.73-7.97-.04-.42-.1-.85-.15-1.29H38.3c-.28,3.25-.56,6.46-.85,9.71a31.929,31.929,0,0,0-8.19,2.53,30.054,30.054,0,0,0-3.01,1.63A.87.87,0,0,1,25,17.1c-2.31-1.98-4.64-3.94-6.89-5.84-1.96,1.96-3.89,3.89-5.85,5.87,1.98,2.36,4.06,4.83,6.16,7.33a29.212,29.212,0,0,0-5.17,11.68c-3.28.28-6.55.56-9.89.85v8.18c.95.1,1.94.2,2.93.29,2,.18,4.01.37,6.01.5.56.04.79.19.89.77a29.679,29.679,0,0,0,4.2,10.8c.29.45.09.67-.17.97l-5.43,6.42c-.19.23-.37.46-.51.62l5.81,5.87c2.1-1.76,4.21-3.55,6.42-5.4.71.84,1.4,1.66,2.15,2.57q-4.455,3.66-8.78,7.21c-3.4-3.4-6.76-6.77-10.17-10.18,1.72-2.03,3.39-4.22,5.29-6.19a2.8,2.8,0,0,0,.53-3.94,28.056,28.056,0,0,1-2.06-5.56c-.21-.7-.48-.96-1.18-1-2.93-.21-5.86-.46-8.79-.69-.15-.01-.31-.05-.5-.08V33.92c1.88-.16,3.76-.34,5.65-.5,1.46-.13,2.92-.26,4.39-.36a.776.776,0,0,0,.79-.64,28.508,28.508,0,0,1,3.27-7.35c.29-.45.07-.68-.18-.97-2.08-2.41-4.16-4.83-6.18-7.18L17.91,6.75c2.42,2.04,4.92,4.13,7.39,6.27a1.062,1.062,0,0,0,1.34.17q3.525-1.455,7.13-2.75c.51-.19.75-.36.79-.92.2-2.93.45-5.86.68-8.79A7.041,7.041,0,0,1,35.37,0H49.56c.1,1.05.22,2.09.31,3.13.18,2.2.38,4.39.53,6.59a1.251,1.251,0,0,0,.97,1.24c2.31.93,4.58,1.97,6.83,3.04a.96.96,0,0,0,1.26-.1c2.4-2.05,4.83-4.07,7.15-6.02C70,11.26,73.36,14.6,76.8,18.03c-.66.8-1.42,1.71-2.19,2.62q-2.055,2.43-4.12,4.85a.849.849,0,0,0-.16,1.14,30.624,30.624,0,0,1,2.85,7.26c.07.27.37.66.6.68,3.25.29,6.5.53,9.75.78V49.73c-2.74.18-5.48.53-8.22.5-1.97-.03-2.76.7-3.31,2.55"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_124"
          data-name="Path 124"
          d="M58.75,49.07c1.04-3.1,1.87-6.24,1.46-9.59A18.68,18.68,0,0,0,37.87,23.45c-10.46,2.2-16.46,12.64-14.29,21.69A38.207,38.207,0,0,0,30.31,59.5a9.038,9.038,0,0,1,1.72,4.66h-2.3v3.33h1.82v2.23H29.71v3.27H53.8V69.68H35V67.46H53.79V64.1H51.37a9.39,9.39,0,0,1,1.73-4.52,36.092,36.092,0,0,0,5.65-10.51M50.49,57.5a16.091,16.091,0,0,0-1.8,3.44c-.52,1.27-.43,1.31-1.98,1.11.09-.98.17-1.97.28-2.95q.7-6.36,1.42-12.72c.13-1.14.13-1.14-1.02-1.27-.73-.08-1.45-.15-2.3-.23-.58,5.77-1.15,11.46-1.74,17.25-.98,0-1.9.02-2.82-.02a.656.656,0,0,1-.42-.45c-.33-3.03-.63-6.05-.93-9.08q-.375-3.57-.71-7.14c-.04-.42-.23-.56-.64-.51a17.436,17.436,0,0,1-2.03.2c-.65.01-.84.27-.76.9.27,2.12.52,4.26.75,6.39.35,3.19.67,6.37,1.02,9.71a4.764,4.764,0,0,1-1.15-.02.984.984,0,0,1-.65-.49,14.848,14.848,0,0,0-2.53-4.88,30.693,30.693,0,0,1-5.78-13.6,13.73,13.73,0,0,1,3.9-11.89c4.27-4.49,9.56-5.98,15.49-4.19,5.87,1.77,9.37,5.9,10.62,11.88.67,3.16-.16,6.16-1.16,9.11a35.88,35.88,0,0,1-5.06,9.45"
          fill="url(#linear-gradient)"
        />
        <rect
          id="Rectangle_60"
          data-name="Rectangle 60"
          width="15.63"
          height="3.27"
          transform="translate(33.87 75.26)"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_125"
          data-name="Path 125"
          d="M40.24,20.95c-1.04.15-1.98.28-2.99.42-.22-1.08-.43-2.1-.66-3.24,1.16-.17,2.21-.33,3.37-.5.1,1.17.19,2.2.28,3.32"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_126"
          data-name="Path 126"
          d="M46.88,18.12c-.24,1.04-.43,1.98-.69,2.91-.03.14-.37.28-.55.26-.78-.08-1.55-.22-2.41-.35.09-1.11.17-2.13.26-3.29,1.14.16,2.2.3,3.39.47"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_127"
          data-name="Path 127"
          d="M63.09,30.14c-1.04.6-1.95,1.12-2.93,1.68-.53-.83-1.03-1.61-1.59-2.47.86-.65,1.72-1.29,2.66-2,.62.92,1.21,1.81,1.86,2.79"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_128"
          data-name="Path 128"
          d="M24.9,29.34c-.54.85-1.05,1.64-1.59,2.48-.96-.53-1.88-1.03-2.89-1.57.62-.99,1.19-1.93,1.8-2.92.94.7,1.8,1.35,2.68,2.01"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_129"
          data-name="Path 129"
          d="M22.01,34.56c-.27.94-.52,1.84-.8,2.81-1.07-.24-2.09-.47-3.25-.74.33-1.1.63-2.12.97-3.23,1.06.4,2.03.77,3.08,1.16"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_130"
          data-name="Path 130"
          d="M65.52,36.64c-1.13.26-2.16.49-3.24.74-.29-.96-.54-1.84-.82-2.8.99-.38,1.96-.75,3.06-1.17.33,1.07.65,2.08,1,3.23"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_131"
          data-name="Path 131"
          d="M29.09,25.17c-.79.67-1.49,1.26-2.2,1.87-.74-.78-1.46-1.54-2.24-2.36.73-.65,1.54-1.36,2.44-2.16.69.92,1.33,1.77,2,2.65"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_132"
          data-name="Path 132"
          d="M34.33,22.24c-.93.43-1.76.82-2.66,1.23-.51-.94-1.01-1.86-1.57-2.9,1.03-.47,2.02-.93,3.06-1.41.4,1.05.77,2.03,1.17,3.08"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_133"
          data-name="Path 133"
          d="M58.76,24.61c-.82.8-1.57,1.54-2.34,2.29-.63-.54-1.35-1.15-2.12-1.81.63-.84,1.26-1.69,1.99-2.66.88.78,1.69,1.49,2.47,2.18"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_134"
          data-name="Path 134"
          d="M53.28,20.57c-.53.99-1.03,1.9-1.55,2.88-.92-.43-1.75-.81-2.66-1.24.37-.98.74-1.96,1.15-3.04,1.01.46,1.98.91,3.06,1.4"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_135"
          data-name="Path 135"
          d="M66.02,41.86H62.71V40.4c1.01-.08,2.05-.16,3.2-.26.04.62.07,1.13.11,1.72"
          fill="url(#linear-gradient)"
        />
        <path
          id="Path_136"
          data-name="Path 136"
          d="M20.74,40.47c-.02.49-.05.91-.07,1.4H17.45V40.24c1.11.08,2.17.15,3.29.23"
          fill="url(#linear-gradient)"
        />
      </g>
    </svg>
  );
};

export const TiktokIcon: React.FC<React.SVGAttributes<{}>> = ({ ...rest }) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");
  return (
    <svg
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      onMouseEnter={() => {
        setColor(rest.color || "#fff");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
    >
      <defs>
        <filter
          id="Ellipse_9"
          x="0"
          y="0"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_10_4"
        data-name="Component 10 – 4"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_9)">
          <circle
            id="Ellipse_9-2"
            data-name="Ellipse 9"
            cx="41.5"
            cy="41.5"
            r="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          fill={color}
          id="Icon_ionic-logo-youtube"
          data-name="Icon ionic-logo-tiktok"
          d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"
          transform="translate(22 22.5)"
        />
      </g>
    </svg>
  );
};

export const YoutubeIcossn: React.FC<React.SVGAttributes<{}>> = ({
  ...rest
}) => {
  const [color, setColor] = useState("#fff");
  const [background, setBackGround] = useState("#1b4a97");

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="101"
      height="101"
      viewBox="0 0 101 101"
      onMouseEnter={() => {
        setColor(rest.color || "#ff0202");
        setBackGround("#fff");
      }}
      onMouseLeave={() => {
        setColor("#fff");
        setBackGround("#1b4a97");
      }}
      {...rest}
    >
      <defs>
        <filter
          id="Ellipse_9"
          x="0"
          y="0"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" in="SourceAlpha" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g
        id="Component_10_4"
        data-name="Component 10 – 4"
        transform="translate(9 6)"
      >
        <g transform="matrix(1, 0, 0, 1, -9, -6)" filter="url(#Ellipse_9)">
          <circle
            id="Ellipse_9-2"
            data-name="Ellipse 9"
            cx="41.5"
            cy="41.5"
            r="41.5"
            transform="translate(9 6)"
            fill={background}
          />
        </g>
        <path
          fill={color}
          id="Icon_ionic-logo-youtube"
          data-name="Icon ionic-logo-youtube"
          d="M38.03,10.841A5.812,5.812,0,0,0,32.5,4.769C28.354,4.575,24.129,4.5,19.815,4.5H18.469c-4.307,0-8.539.075-12.682.269A5.825,5.825,0,0,0,.262,10.856C.075,13.518-.007,16.18,0,18.842s.075,5.324.254,7.993A5.832,5.832,0,0,0,5.78,32.929c4.352.2,8.816.292,13.355.284q6.819.022,13.355-.284a5.833,5.833,0,0,0,5.533-6.094c.179-2.669.262-5.331.254-8Q38.3,14.841,38.03,10.841ZM15.478,26.177V11.484L26.32,18.827Z"
          transform="translate(22 22.5)"
        />
      </g>
    </svg>
  );
};

export const CloudUpload = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4.5C9.58676 4.5 7.61684 6.39994 7.50502 8.78512C7.48627 9.18524 7.15641 9.5 6.75585 9.5H6.5C4.84315 9.5 3.5 10.8431 3.5 12.5C3.5 14.1569 4.84315 15.5 6.5 15.5H10.0764C10.0261 15.826 10 16.1599 10 16.5C10 16.6682 10.0064 16.835 10.0189 17H6.5C4.01472 17 2 14.9853 2 12.5C2 10.1564 3.79155 8.23125 6.07981 8.01936C6.54808 5.17188 9.02022 3 12 3C14.9798 3 17.4519 5.17189 17.9202 8.01936C20.2085 8.23125 22 10.1564 22 12.5C22 12.6664 21.991 12.8307 21.9734 12.9925C21.5031 12.2601 20.8898 11.6283 20.1729 11.1365C19.6764 10.165 18.6659 9.5 17.5 9.5H17.2442C16.8436 9.5 16.5137 9.18524 16.495 8.78512C16.3832 6.39994 14.4132 4.5 12 4.5ZM22 16.5C22 19.5376 19.5376 22 16.5 22C13.4624 22 11 19.5376 11 16.5C11 13.4624 13.4624 11 16.5 11C19.5376 11 22 13.4624 22 16.5ZM16 19.5C16 19.7761 16.2239 20 16.5 20C16.7761 20 17 19.7761 17 19.5V14.7071L18.6464 16.3536C18.8417 16.5488 19.1583 16.5488 19.3536 16.3536C19.5488 16.1583 19.5488 15.8417 19.3536 15.6464L16.8536 13.1464C16.6583 12.9512 16.3417 12.9512 16.1464 13.1464L13.6464 15.6464C13.4512 15.8417 13.4512 16.1583 13.6464 16.3536C13.8417 16.5488 14.1583 16.5488 14.3536 16.3536L16 14.7071V19.5Z"
          fill="#212121"
        />
      </svg>
    </SvgIcon>
  );
};

export const Delete = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 5H14C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5ZM8.5 5C8.5 3.067 10.067 1.5 12 1.5C13.933 1.5 15.5 3.067 15.5 5H21.25C21.6642 5 22 5.33579 22 5.75C22 6.16421 21.6642 6.5 21.25 6.5H19.9309L18.7589 18.6112C18.5729 20.5334 16.9575 22 15.0263 22H8.97369C7.04254 22 5.42715 20.5334 5.24113 18.6112L4.06908 6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.33579 2.33579 5 2.75 5H8.5ZM10.5 9.75C10.5 9.33579 10.1642 9 9.75 9C9.33579 9 9 9.33579 9 9.75V17.25C9 17.6642 9.33579 18 9.75 18C10.1642 18 10.5 17.6642 10.5 17.25V9.75ZM14.25 9C14.6642 9 15 9.33579 15 9.75V17.25C15 17.6642 14.6642 18 14.25 18C13.8358 18 13.5 17.6642 13.5 17.25V9.75C13.5 9.33579 13.8358 9 14.25 9ZM6.73416 18.4667C6.84577 19.62 7.815 20.5 8.97369 20.5H15.0263C16.185 20.5 17.1542 19.62 17.2658 18.4667L18.4239 6.5H5.57608L6.73416 18.4667Z"
          fill="#212121"
        />
      </svg>
    </SvgIcon>
  );
};